/**
* Hisense SP Interface catalogs (Spain market).
* Source: "Hisense SP Interface List_ES_V1.1_202412.xlsx"
*/

export const warrantyTypes = [
    { code: 'I', label: 'I — In Warranty' },
    { code: 'O', label: 'O — Out of Warranty' },
    { code: 'D', label: 'D - DOA' },
    { code: 'M', label: 'M — Extended (Marketing)' },
    { code: 'E', label: 'E — Goodwill' },
];

export const serviceTypes = [
    { code: '01', label: '01 — On-Site' },
    { code: '13', label: '13 — Pick up & Repair' },
];

export const serviceStatuses = [
    { code: 'E0003', label: 'E0003 — Reconhecido / Recebido' },
    { code: 'E0014', label: 'E0014 — Reparação Concluída' }
];

export const inProgressStatuses = [
    { code: 'ES002', label: 'ES002 — Atribuído' },
    { code: 'ES003', label: 'ES003 — Visita agendada' },
    { code: 'ES005', label: 'ES005 — Equipamento na oficina' },
    { code: 'ES009', label: 'ES009 — Cancelado' },
    { code: 'ES010', label: 'ES010 — Confirmado' },
    { code: 'ES015', label: 'ES015 — Peças pendentes na Sede, data prevista a tempo (≤15 dias)' },
    { code: 'ES016', label: 'ES016 — Peças pendentes na Sede, data prevista atrasada (>15 dias / Não Disponível)' },
    { code: 'ES019', label: 'ES019 — Em espera - em consulta técnica' }
];

export const delayReasons = [
    { code: '40', label: '40 — Hisense - Invalid or Incomplete Dispatch' },
    { code: '41', label: '41 — Hisense - Part Is On Backorder' },
    { code: '42', label: '42 — Hisense - Part Was Damaged' },
    { code: '43', label: '43 — Hisense - Part Tracking Delay' },
    { code: '44', label: '44 — Hisense - Wrong Part Received' },
    { code: '45', label: '45 — EU - Customer Requested Change' },
    { code: '46', label: '46 — EU - Unsuccessful Customer Contact' },
    { code: '47', label: '47 — EU - Customer Not Home' },
    { code: '48', label: '48 — Servicer - Remote Customer Address' },
    { code: '49', label: '49 — Servicer - Servicer Requested Change' },
    { code: '50', label: '50 — Weather' },
    { code: '51', label: '51 — Other - Enter Comments' },
];

export const unsolvedReasons = [
    { code: '1', label: '1 — Additional Parts Required' },
    { code: '2', label: '2 — Additional Problem Found' },
    { code: '3', label: '3 — Damaged Screen' },
    { code: '4', label: '4 — DOA Parts' },
    { code: '5', label: '5 — Environment Issue' },
    { code: '6', label: '6 — Failed After Repair' },
    { code: '7', label: '7 — Known Issue/Please advise' },
    { code: '8', label: '8 — Misdiagnose' },
    { code: '9', label: '9 — Missing Parts' },
    { code: '10', label: '10 — Physical Damage' },
    { code: '11', label: '11 — Wrong Parts/Wrong Model' },
    { code: '12', label: '12 — Panel Problem' },
];

export const partsOrderTypes = [
    { code: 'ZSO2', label: 'ZSO2 — HSI Client Sales (a faturar)' },
    { code: 'ZSO5', label: 'ZSO5 — HSI Free Sales (gratuito / garantia)' },
];

export const partsItemStatuses = [
    { code: 'E0001', label: 'E0001 — Open' },
    { code: 'E0004', label: 'E0004 — Consumed' },
    { code: 'E0005', label: 'E0005 — Refurbish parts' },
    { code: 'E0006', label: 'E0006 — Canceled' },
    { code: 'E0007', label: 'E0007 — Not Used' },
    { code: 'E0008', label: 'E0008 — Defective' },
    { code: 'E00009', label: 'E00009 — Free of Charge' },
];

export const codeGroups = [
    { code: 'AC1', label: 'AC1 — Ar Condicionado' },
    { code: 'BAR', label: 'BAR — Barra de Som / Soundbar' },
    { code: 'CD1', label: 'CD1 — Ecrãs Comerciais / Digital Signage' },
    { code: 'DH1', label: 'DH1 — Desumidificador' },
    { code: 'DW1', label: 'DW1 — Máquinas de Lavar Loiça' },
    { code: 'FF1', label: 'FF1 — Arca Congeladora / Congelador' },
    { code: 'KA1', label: 'KA1 — Eletrodomésticos de Cozinha' },
    { code: 'LS1', label: 'LS1 — Laser TV' },
    { code: 'MP1', label: 'MP1 — Telemóvel / Smartphone' },
    { code: 'PAD', label: 'PAD — Tablet' },
    { code: 'POS', label: 'POS — POS / Terminal de Ponto de Venda' },
    { code: 'RF1', label: 'RF1 — Frigorífico' },
    { code: 'SH1', label: 'SH1 — Eletrodomésticos' },
    { code: 'TV1', label: 'TV1 — Televisão / TV' },
    { code: 'WC1', label: 'WC1 — Garrafeira Climatizada / Cave de Vinhos' },
    { code: 'WM1', label: 'WM1 — Máquinas de Lavar Roupa' },
];

export const symptomCodes = {
    AC1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [{ sCode: '111', sDes: 'Sem alimentação / Não liga' }, { sCode: '118', sDes: 'Função de desligar não funciona' }, { sCode: '11A', sDes: 'Dá sinal/Liga mas não funciona' }, { sCode: '11B', sDes: 'Ciclo intermitente de ligar/desligar' }, { sCode: '11H', sDes: 'Disjuntor de proteção interno dispara' }] },
        { fCode: '120', fDes: 'Problema de carga / Problema de nível', subCodes: [{ sCode: '124', sDes: 'Aquecimento / temperatura insuficiente' }, { sCode: '125', sDes: 'Aquecimento / temperatura excessiva' }, { sCode: '126', sDes: 'Arrefecimento insuficiente (não específico)' }, { sCode: '127', sDes: 'Arrefecimento excessivo (não específico)' }, { sCode: '12A1', sDes: 'Sinal Wi-Fi instável' }] },
        { fCode: '130', fDes: 'Problema na função de visualização / ecrã', subCodes: [{ sCode: '130', sDes: 'Problema na função de visualização / ecrã' }, { sCode: '131', sDes: 'Ecrã sem imagem ou com falhas' }, { sCode: '138', sDes: 'Visualização de alarme / erro com falha' }, { sCode: '139', sDes: 'Ecrã fraco / parcial / etc.' }, { sCode: '13D', sDes: 'Luz de aviso não funciona' }, { sCode: '13E', sDes: 'Luz de aviso acesa permanente' }, { sCode: '13F', sDes: 'Segmento(s) em falta no ecrã' }] },
        { fCode: '140', fDes: 'Ruído anómalo', subCodes: [{ sCode: '140', sDes: 'Ruído anómalo' }, { sCode: '143', sDes: 'Ruído no chassis / vibração de tabuleiros' }, { sCode: '145', sDes: 'Componente(s) ruidoso(s)' }, { sCode: '149', sDes: 'Estalidos' }, { sCode: '14A', sDes: 'Assobio' }, { sCode: '14F', sDes: 'Chiar / Ruído agudo' }, { sCode: '14G', sDes: 'Ruído de fricção' }, { sCode: '14I', sDes: 'Ruído de bombagem' }, { sCode: '14J', sDes: 'Ruído eletromagnético' }, { sCode: '14K', sDes: 'Ruído na aba de nível' }, { sCode: '14L', sDes: 'Ruído no defletor vertical / louver' }, { sCode: '14M', sDes: 'Ruído de fluxo do refrigerante' }, { sCode: '14X', sDes: 'Outro tipo de ruído anómalo' }] },
        { fCode: '150', fDes: 'Problema no controlo remoto / comando', subCodes: [{ sCode: '151', sDes: 'Comando não funciona' }, { sCode: '152', sDes: 'Funcionamento incorreto do comando' }, { sCode: '154', sDes: 'Comando com pouca sensibilidade' }, { sCode: '15A1', sDes: 'Consumo excessivo de pilhas no comando' }] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [{ sCode: '163', sDes: 'Manípulo(s) de controlo / botão(ões) danificado(s)' }, { sCode: '16E', sDes: 'Danos na superfície externa' }, { sCode: '16L', sDes: 'Marcas de queimado' }, { sCode: '16M', sDes: 'Danos na superfície interna' }, { sCode: '16N', sDes: 'Cabo de alimentação danificado' }, { sCode: '16P', sDes: 'Acessório danificado' }, { sCode: '16R', sDes: 'Descoloração' }, { sCode: '16S', sDes: 'Cliente magoado / ferido' }, { sCode: '16U', sDes: 'Embalagem danificada' }] },
        { fCode: '168', fDes: 'Má aparência', subCodes: [{ sCode: '168', sDes: 'Má aparência' }] },
        { fCode: '170', fDes: 'Problema de funcionamento geral', subCodes: [{ sCode: '17B', sDes: 'Choque elétrico / descarga estática' }, { sCode: '17F', sDes: 'Interruptor / teclado não funciona' }, { sCode: '17M', sDes: 'Falha na comutação de modo' }, { sCode: '17P', sDes: 'Falha na função de controlo do utilizador' }, { sCode: '17S', sDes: 'Temperatura não ajustável' }] },
        { fCode: '190', fDes: 'Odor / Cheiro', subCodes: [{ sCode: '191', sDes: 'Cheiro a queimado' }, { sCode: '193', sDes: 'Cheiro a borracha' }, { sCode: '194', sDes: 'Cheiro a podre / águas residuais' }, { sCode: '195', sDes: 'Cheiro a plástico' }, { sCode: '196', sDes: 'Cheiro a cloro' }, { sCode: '19A', sDes: 'Cheiro a combustível / óleo' }] },
        { fCode: '610', fDes: 'Sem funcionamento mecânico', subCodes: [{ sCode: '610', sDes: 'Sem funcionamento mecânico' }, { sCode: '61B', sDes: 'Controlo / interruptor não funciona' }, { sCode: '61F', sDes: 'Aba de nível não fecha (unidade desliga)' }, { sCode: '61G', sDes: 'Aba de nível não oscila' }, { sCode: '61H', sDes: 'Defletor vertical não oscila' }] },
        { fCode: '650', fDes: 'Instabilidade mecânica', subCodes: [{ sCode: '650', sDes: 'Instabilidade mecânica' }, { sCode: '651', sDes: 'Pés desnivelados' }, { sCode: '653', sDes: 'A vibrar / a saltar' }, { sCode: '654', sDes: 'Componente(s) solto(s)' }] },
        { fCode: 'B10', fDes: 'Não funciona / Sem função', subCodes: [{ sCode: 'B10', sDes: 'Não funciona / Sem função' }, { sCode: 'B11', sDes: 'Não arrefece' }, { sCode: 'B16', sDes: 'Não descongela' }, { sCode: 'B17', sDes: 'Não desumidifica' }, { sCode: 'B1A1', sDes: 'Não liga ao Wi-Fi' }, { sCode: 'B1A2', sDes: 'Não aquece' }, { sCode: 'B1D', sDes: 'Funcionamento anómalo' }] },
        { fCode: 'B50', fDes: 'Fuga', subCodes: [{ sCode: 'B50', sDes: 'Fuga' }, { sCode: 'B51', sDes: 'Fuga de combustível / óleo' }, { sCode: 'B52', sDes: 'Fuga de fuligem' }, { sCode: 'B53', sDes: 'Emissão de fumo' }, { sCode: 'B54', sDes: 'Fuga de água' }, { sCode: 'B55', sDes: 'Compressor enferrujado e a verter' }, { sCode: 'B56', sDes: 'Expele água pela saída de ar' }] },
        { fCode: 'PC', fDes: 'Recolha de Produto Defeituoso', subCodes: [{ sCode: 'PC', sDes: 'Recolha de Produto Defeituoso' }] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [{ sCode: 'Y4', sDes: 'Instalação do produto' }] },
    ],
    BAR: [
        { fCode: '111', fDes: 'Sem Alimentação / Não liga', subCodes: [] },
        { fCode: '119', fDes: 'Não sai do modo standby / espera', subCodes: [] },
        { fCode: '11D', fDes: 'Desliga-se sozinho', subCodes: [] },
        { fCode: '11X', fDes: 'Outro problema de energia', subCodes: [] },
        { fCode: '140', fDes: 'Ruído anómalo', subCodes: [] },
        { fCode: '151', fDes: 'Controlo remoto não funciona', subCodes: [] },
        { fCode: '154', fDes: 'Fraca sensibilidade do controlo remoto', subCodes: [] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [] },
        { fCode: '161', fDes: 'Tampa / carcaça danificada ou deformada', subCodes: [] },
        { fCode: '163', fDes: 'Problema nos botões / botões do comando', subCodes: [] },
        { fCode: '166', fDes: 'Ficha/Porta/Conector/Ranhura de cartões danificada', subCodes: [] },
        { fCode: '168', fDes: 'Cartucho ou agulha danificada', subCodes: [] },
        { fCode: '16F', fDes: 'Cheiro estranho / peculiar', subCodes: [] },
        { fCode: '16H', fDes: 'Altifalante danificado', subCodes: [] },
        { fCode: '16N', fDes: 'Cabo de alimentação danificado', subCodes: [] },
        { fCode: '16P', fDes: 'Acessório danificado', subCodes: [] },
        { fCode: '16X', fDes: 'Outro dano físico', subCodes: [] },
        { fCode: '186', fDes: 'Produto errado na caixa', subCodes: [] },
        { fCode: '187', fDes: 'Acessório errado ou em falta', subCodes: [] },
        { fCode: '232', fDes: 'Transmissão / ligação deficiente', subCodes: [] },
        { fCode: '510', fDes: 'Sem Áudio / Sem som', subCodes: [] },
        { fCode: '519', fDes: 'Sem som na saída digital', subCodes: [] },
        { fCode: '51X', fDes: 'Outro problema de Som', subCodes: [] },
        { fCode: '521', fDes: 'Volume de áudio baixo', subCodes: [] },
        { fCode: '522', fDes: 'Volume de áudio excessivo', subCodes: [] },
        { fCode: '530', fDes: 'Qualidade do áudio', subCodes: [] },
        { fCode: '715', fDes: 'Teclado não funciona', subCodes: [] },
        { fCode: '781', fDes: 'Problema na interface USB', subCodes: [] },
        { fCode: '78A', fDes: 'Problema de Bluetooth / infravermelhos', subCodes: [] },
    ],
    CD1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [{ sCode: '111', sDes: 'Sem Alimentação / Não liga' }, { sCode: '1140', sDes: 'Bloqueado no LOGO / Congelado' }, { sCode: '119', sDes: 'Não sai do modo standby / espera' }, { sCode: '11B', sDes: 'Ciclo intermitente de ligar/desligar' }, { sCode: '11D', sDes: 'Desliga-se sozinho' }, { sCode: '11K', sDes: 'Arranque inicial demasiado lento' }, { sCode: '11X', sDes: 'Outro problema de energia' }, { sCode: '35A', sDes: 'Imagem / ecrã congelado' }] },
        { fCode: '150', fDes: 'Problema no controlo remoto / comando', subCodes: [{ sCode: '151', sDes: 'Controlo remoto não funciona' }, { sCode: '152', sDes: 'Resposta incorreta do comando' }, { sCode: '153', sDes: 'Problema de programação / aprendizagem do comando' }, { sCode: '154', sDes: 'Fraca sensibilidade do controlo remoto' }, { sCode: '1550', sDes: 'Assistente de voz não funciona' }, { sCode: '1590', sDes: 'Função de voz inteligente não funciona' }, { sCode: 'T156', sDes: 'Controlo remoto não emparelha / incompatível' }, { sCode: 'T157', sDes: 'Tecla do comando presa' }, { sCode: 'T158', sDes: 'Emparelhamento Bluetooth do comando anómalo' }] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [{ sCode: '161', sDes: 'Tampa / carcaça danificada ou deformada' }, { sCode: '1620', sDes: 'Ecrã / painel curvado' }, { sCode: '164', sDes: 'Ecrã descolado do chassis' }, { sCode: '1650', sDes: 'Painel empenado / a cair' }, { sCode: '166', sDes: 'Ficha/Porta/Conector/Ranhura de cartões danificada' }, { sCode: '1680', sDes: 'LOGO da tampa frontal incorreto' }, { sCode: '16A1', sDes: 'Ecrã / painel danificado' }, { sCode: '16A2', sDes: 'Ecrã / painel riscado' }, { sCode: '16A3', sDes: 'Folga na tampa / chassis' }, { sCode: '16A4', sDes: 'Embalagem danificada' }, { sCode: '16A5', sDes: 'Manípulo/Botão/Teclado danificado' }, { sCode: '16D', sDes: 'TV a queimar / Fumo / Fogo' }, { sCode: '16F', sDes: 'Cheiro estranho / peculiar' }, { sCode: '16J', sDes: 'TV muito quente / componentes a derreter' }, { sCode: '16K', sDes: 'Corpo estranho no ecrã' }, { sCode: '16N', sDes: 'Cabo de alimentação danificado' }, { sCode: '16W', sDes: 'Material estranho (fora do painel)' }] },
        { fCode: '170', fDes: 'Problema de funcionamento geral', subCodes: [{ sCode: '17A1', sDes: 'Menu do sistema inacessível / não funciona' }, { sCode: '17D', sDes: 'Idioma incorreto / conjunto de caracteres do LOGO com erro' }, { sCode: '17N', sDes: 'Problema na função do menu' }, { sCode: '21A3', sDes: 'Edição de canais anómala' }, { sCode: '21A4', sDes: 'Gravação com anomalia' }] },
        { fCode: 'A120', fDes: 'Problema na função de aplicação (APP)', subCodes: [{ sCode: '12A1', sDes: 'Aplicação fecha sozinha' }, { sCode: '12A2', sDes: 'Aplicação congelada / bloqueada' }, { sCode: '12A3', sDes: 'Não liga após atualização OTA' }, { sCode: '12A4', sDes: 'Funcionamento anómalo após atualização OTA' }, { sCode: '12A5', sDes: 'Falha no download da OTA' }, { sCode: '12A7', sDes: 'Aplicação não funciona' }, { sCode: '12A8', sDes: 'Reprodução de vídeo online congelada' }, { sCode: '12B2', sDes: 'Navegador com funcionamento anómalo' }, { sCode: '21A2', sDes: 'Rede / Wi-Fi indisponível' }, { sCode: '781', sDes: 'Problema na interface USB' }] },
        { fCode: 'A210', fDes: 'Sem receção / Problema de ligação', subCodes: [{ sCode: '216', sDes: 'Sem sinal BS/CS' }, { sCode: '217', sDes: 'Sem sinal CS' }, { sCode: '218', sDes: 'Sem sinal de TV' }, { sCode: '21A1', sDes: 'AV/VGA/HDMI não funcionam' }, { sCode: '21A2', sDes: 'Rede / Wi-Fi indisponível' }] },
        { fCode: 'A310', fDes: 'Problema de imagem / ecrã / visualização', subCodes: [{ sCode: '16K', sDes: 'Corpo estranho no ecrã' }, { sCode: '3120', sDes: 'Ponto brilhante/preto/cor no ecrã (Pixel)' }, { sCode: '3130', sDes: 'TV mostra estado "M" (Modo Fábrica)' }, { sCode: '3140', sDes: 'Ecrã queimado / Burn-in' }, { sCode: '3150', sDes: 'Ecrã sujo' }, { sCode: '3160', sDes: 'Derrame de líquido do painel' }, { sCode: '3170', sDes: 'Desfasamento de áudio/vídeo (Lip Sync)' }, { sCode: '3180', sDes: 'Metade da imagem escura / anómala' }, { sCode: '3190', sDes: 'Imagem invertida / espelhada' }, { sCode: '31A0', sDes: 'Imagem instável' }, { sCode: '31A1', sDes: 'Sem imagem e sem retroiluminação (Backlight)' }, { sCode: '31A2', sDes: 'Sem imagem mas tem retroiluminação (Backlight)' }, { sCode: '31A4', sDes: 'Ecrã branco' }, { sCode: '31A5', sDes: 'Fuga de luz' }, { sCode: '31A6', sDes: 'Exibição HDR com anomalia' }, { sCode: '31A7', sDes: 'Imagem desfocada' }, { sCode: '31A8', sDes: 'Atraso de entrada / Input Lag' }, { sCode: '31A9', sDes: 'Interferência na imagem' }, { sCode: '321', sDes: 'Imagem demasiado escura' }, { sCode: '34C', sDes: 'Efeito Clouding / "MURA"' }, { sCode: '355', sDes: 'Imagem a piscar / Flicker' }, { sCode: '385', sDes: 'Píxeis brilhantes, escuros ou intermitentes' }, { sCode: '38G', sDes: 'Linhas ou faixas verticais' }, { sCode: '38H', sDes: 'Linhas ou faixas horizontais' }, { sCode: '420', sDes: 'Problema no nível de cor' }] },
        { fCode: 'A510', fDes: 'Problema de áudio / ruído', subCodes: [{ sCode: '140', sDes: 'Ruído anómalo' }, { sCode: '510', sDes: 'Sem áudio' }, { sCode: '5120', sDes: 'Som do dispositivo externo anómalo' }, { sCode: '5130', sDes: 'Som da barra de som anómalo' }, { sCode: '517', sDes: 'Sem som nos auscultadores' }, { sCode: '519', sDes: 'Sem som na saída digital' }, { sCode: '51A1', sDes: 'Ligação ARC sem som' }, { sCode: '51A2', sDes: 'Sem saída de som em AV/VGA/HDMI' }, { sCode: '51X', sDes: 'Outro problema de som' }, { sCode: '521', sDes: 'Volume de áudio baixo' }, { sCode: '522', sDes: 'Volume de áudio elevado' }, { sCode: '5230', sDes: 'Som fora de controlo' }, { sCode: '54B', sDes: 'Som imperfeito / distorcido' }, { sCode: '553', sDes: 'Cortes intermitentes no áudio' }, { sCode: '645', sDes: 'Ruído anómalo na ventoinha' }] },
        { fCode: 'A740', fDes: 'Teclado / Botão tátil', subCodes: [{ sCode: '163', sDes: 'Problema nos botões / comando' }, { sCode: '741', sDes: 'Botão / botão tátil não funciona' }, { sCode: '744', sDes: 'Tecla presa / dura de pressionar' }, { sCode: '74A1', sDes: 'Modelo de comando não corresponde a esta TV' }, { sCode: '74A2', sDes: 'Botão/tecla pouco sensível' }] },
        { fCode: 'A810', fDes: 'Problema com acessório / base', subCodes: [{ sCode: '81A1', sDes: 'Sem acessórios' }, { sCode: '81A2', sDes: 'Sem comando' }, { sCode: '81A3', sDes: 'Sem cartão CI / cartão B-CAS' }, { sCode: '81A4', sDes: 'Sem suporte de base' }, { sCode: '81A5', sDes: 'Sem parafusos / parafusos incorretos' }, { sCode: '81A6', sDes: 'Sem base / base incorreta' }, { sCode: '81A7', sDes: 'Comando incorreto' }, { sCode: '81A8', sDes: 'Acessório incorreto' }, { sCode: '81A9', sDes: 'Acessório danificado' }, { sCode: '81B1', sDes: 'Base danificada' }, { sCode: '81B2', sDes: 'Sem manual' }, { sCode: '81B3', sDes: 'Outro problema de acessórios' }, { sCode: '81B4', sDes: 'Base instável' }, { sCode: '81B5', sDes: 'Rosca espanada na base' }, { sCode: '81B6', sDes: 'Falta de proteção de borracha na base' }, { sCode: 'Z0A3', sDes: 'Não é possível instalar o suporte de parede' }, { sCode: 'Z0A4', sDes: 'Não é possível instalar a base' }, { sCode: 'Z0A5', sDes: 'Base não desmonta' }] },
        { fCode: 'HT00', fDes: 'Problema na projeção sem fios (Cast)', subCodes: [{ sCode: 'HT01', sDes: 'Não consegue partilhar ecrã' }, { sCode: 'HT02', sDes: 'Atraso / lag na partilha de ecrã' }] },
        { fCode: 'LED0', fDes: 'Problema no produto LED', subCodes: [{ sCode: 'LED1', sDes: 'Módulo não acende' }, { sCode: 'LED2', sDes: 'Módulo fora de controlo' }, { sCode: 'LED3', sDes: 'Módulo sem sinal' }, { sCode: 'LED4', sDes: 'Chassis do ecrã não acende' }, { sCode: 'LED5', sDes: 'Lâmpada/díodo não acende' }, { sCode: 'LED6', sDes: 'Lâmpada/díodo sempre aceso' }, { sCode: 'LED7', sDes: 'Sem sinal' }, { sCode: 'LED8', sDes: 'Ecrã preto' }, { sCode: 'LED9', sDes: 'Ecrã intermitente / a piscar' }] },
        { fCode: 'SX00', fDes: 'Problema na função tátil', subCodes: [{ sCode: 'SX01', sDes: 'Função tátil OPS não funciona' }, { sCode: 'SX02', sDes: 'Função tátil OPS e PC externo não funciona' }, { sCode: 'SX03', sDes: 'Função tátil Android não funciona' }, { sCode: 'SX04', sDes: 'Ponto de toque salta automaticamente' }, { sCode: 'SX05', sDes: 'Desvio do ponto de toque (descalibrado)' }, { sCode: 'SX06', sDes: 'Função tátil local não funciona/desligada' }, { sCode: 'SX07', sDes: 'Função tátil (OPS e Android) não funciona' }, { sCode: 'SX08', sDes: 'Toque clique pouco sensível' }, { sCode: 'SX09', sDes: 'Atraso nítido no toque' }, { sCode: 'SX10', sDes: 'OPS sem sinal ou ecrã azul' }, { sCode: 'SX11', sDes: 'Mau funcionamento do sistema OPS' }] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [{ sCode: 'Y4', sDes: 'Instalação do produto' }] },
        { fCode: 'Z00', fDes: 'Outros problemas', subCodes: [{ sCode: 'Z01', sDes: 'Questão de instalação/requisito do utilizador' }, { sCode: 'Z02', sDes: 'Depuração / Teste / Verificação' }, { sCode: 'Z03', sDes: 'Requer configuração no arranque' }, { sCode: 'Z04', sDes: 'Produto errado na embalagem' }, { sCode: 'Z05', sDes: 'Danificado pelo cliente' }, { sCode: 'Z06', sDes: 'Lesão do consumidor' }, { sCode: 'Z07', sDes: 'Danos materiais' }] },
    ],
    DH1: [
        { fCode: 'AA01', fDes: 'Não arrefece', subCodes: [] },
        { fCode: 'AA02', fDes: 'Não arrefece bem', subCodes: [] },
        { fCode: 'AA03', fDes: 'Não aquece', subCodes: [] },
        { fCode: 'AA04', fDes: 'Não aquece bem', subCodes: [] },
        { fCode: 'AA05', fDes: 'Sobrecarga do compressor', subCodes: [] },
        { fCode: 'AA06', fDes: 'Sem fluxo de ar na unidade interior', subCodes: [] },
        { fCode: 'AA07', fDes: 'Evaporador com gelo / a congelar' },
        { fCode: 'AA08', fDes: 'Defletor / louver não oscila', subCodes: [] },
        { fCode: 'AA09', fDes: 'Válvula com gelo', subCodes: [] },
        { fCode: 'AA10', fDes: 'Não liga', subCodes: [] },
        { fCode: 'AA11', fDes: 'Compressor não para', subCodes: [] },
        { fCode: 'AB01', fDes: 'Ecrã mostra caracteres ilegíveis', subCodes: [] },
        { fCode: 'AB02', fDes: 'Unidade interior sem visualização / ecrã apagado', subCodes: [] },
        { fCode: 'AB03', fDes: 'Placa de controlo não responde', subCodes: [] },
        { fCode: 'AB04', fDes: 'Alarme na placa de exibição', subCodes: [] },
        { fCode: 'AB05', fDes: 'Motor do ventilador interior não funciona', subCodes: [] },
        { fCode: 'AB06', fDes: 'Motor do ventilador exterior não funciona', subCodes: [] },
        { fCode: 'AB07', fDes: 'Problema no controlo remoto / comando', subCodes: [] },
        { fCode: 'AB08', fDes: 'Não recebe sinal do comando', subCodes: [] },
        { fCode: 'AC01', fDes: 'Compressor não arranca', subCodes: [] },
        { fCode: 'AC02', fDes: 'Condensador com gelo', subCodes: [] },
        { fCode: 'AC03', fDes: 'Ecrã da unidade interior exibe códigos de erro', subCodes: [] },
        { fCode: 'AD01', fDes: 'Fuga de água na unidade interior', subCodes: [] },
        { fCode: 'AD02', fDes: 'Fuga de água na unidade exterior', subCodes: [] },
        { fCode: 'AD03', fDes: 'Ventilador interior expele água', subCodes: [] },
        { fCode: 'AD04', fDes: 'Condensação no painel interior', subCodes: [] },
        { fCode: 'AD05', fDes: 'Ruído em componentes internos', subCodes: [] },
        { fCode: 'AE01', fDes: 'Ruído no sistema de arrefecimento', subCodes: [] },
        { fCode: 'AE02', fDes: 'Ruído no sistema de ventilação/motor', subCodes: [] },
        { fCode: 'AE03', fDes: 'Compressor ruidoso', subCodes: [] },
        { fCode: 'AE04', fDes: 'Superfície enferrujada', subCodes: [] },
        { fCode: 'AE05', fDes: 'Superfície irregular ou com contração', subCodes: [] },
        { fCode: 'AE06', fDes: 'Superfície partida / rachada', subCodes: [] },
        { fCode: 'AE07', fDes: 'Chassis deformado', subCodes: [] },
        { fCode: 'AE08', fDes: 'Odor / Cheiro', subCodes: [] },
        { fCode: 'AE09', fDes: 'Fuga de eletricidade / passagem', subCodes: [] },
    ],
    DW1: [
        { fCode: 'EE01', fDes: 'Exibe modo Showroom / modo de teste', subCodes: [] },
        { fCode: 'EE02', fDes: 'Cablagem incorreta', subCodes: [] },
        { fCode: 'EE03', fDes: 'Curto-circuito', subCodes: [] },
        { fCode: 'EE04', fDes: 'Componente não liga', subCodes: [] },
        { fCode: 'EE05', fDes: 'Componente não desliga', subCodes: [] },
        { fCode: 'EE06', fDes: 'Mau contacto elétrico solto', subCodes: [] },
        { fCode: 'EE07', fDes: 'Mau contacto', subCodes: [] },
        { fCode: 'EE08', fDes: 'Contacto queimado / incandescente / derretido', subCodes: [] },
        { fCode: 'EE09', fDes: 'Descarga atmosférica / raio', subCodes: [] },
        { fCode: 'EE10', fDes: 'Cablagem danificada', subCodes: [] },
        { fCode: 'EE11', fDes: 'Software bloqueado (reconfigurável)', subCodes: [] },
        { fCode: 'EE12', fDes: 'Para durante o programa', subCodes: [] },
        { fCode: 'EE13', fDes: 'Fagulhas / faíscas incorretas', subCodes: [] },
        { fCode: 'EE14', fDes: 'Oscilação da tensão de rede', subCodes: [] },
        { fCode: 'EE15', fDes: 'Componente abre sozinho involuntariamente', subCodes: [] },
        { fCode: 'EE17', fDes: 'Hora incorreta', subCodes: [] },
        { fCode: 'EE20', fDes: 'Ecrã com leitura difícil / cor errada', subCodes: [] },
        { fCode: 'EE27', fDes: 'Elemento mal fixado', subCodes: [] },
        { fCode: 'EE29', fDes: 'Atualização de software', subCodes: [] },
        { fCode: 'EE30', fDes: 'Fagulhas no interior do forno', subCodes: [] },
        { fCode: 'EE31', fDes: 'Relógio adianta / atrasa', subCodes: [] },
        { fCode: 'FC06', fDes: 'Fuga de água / vedação deficiente', subCodes: [] },
        { fCode: 'FC07', fDes: 'Não mete água (gerador de vapor)', subCodes: [] },
        { fCode: 'FD01', fDes: 'Secagem deficiente', subCodes: [] },
        { fCode: 'FF02', fDes: 'Lavagem / enxaguamento deficiente', subCodes: [] },
        { fCode: 'FF05', fDes: 'Desempenho de cozedura deficiente', subCodes: [] },
        { fCode: 'FF06', fDes: 'Formação de gotas / condensação', subCodes: [] },
        { fCode: 'FF07', fDes: 'Queima / combustão', subCodes: [] },
        { fCode: 'FF08', fDes: 'Gás não acendeu', subCodes: [] },
        { fCode: 'FF09', fDes: 'Gás apaga-se', subCodes: [] },
        { fCode: 'FF11', fDes: 'Liga/desliga automaticamente por si só', subCodes: [] },
        { fCode: 'FF12', fDes: 'Configuração do equipamento', subCodes: [] },
        { fCode: 'FF13', fDes: 'Sem deteção de recipiente na placa de indução', subCodes: [] },
        { fCode: 'FF14', fDes: 'Temperatura demasiado alta', subCodes: [] },
        { fCode: 'FF15', fDes: 'Temperatura demasiado baixa', subCodes: [] },
        { fCode: 'FF16', fDes: 'Funcionamento preso / duro', subCodes: [] },
        { fCode: 'FF17', fDes: 'Acumulação de água', subCodes: [] },
        { fCode: 'FF18', fDes: 'Falha no nível da água', subCodes: [] },
        { fCode: 'GG01', fDes: 'Queimado / explodido / incandescente', subCodes: [] },
        { fCode: 'GG02', fDes: 'Gás errado / conversão para outro tipo de gás', subCodes: [] },
        { fCode: 'GG03', fDes: 'Pressão errada', subCodes: [] },
        { fCode: 'GG04', fDes: 'Ajuste / calibração', subCodes: [] },
        { fCode: 'GG05', fDes: 'Fuga de gás', subCodes: [] },
        { fCode: 'GG06', fDes: 'Configuração errada em fábrica', subCodes: [] },
        { fCode: 'MM01', fDes: 'Corpo estranho', subCodes: [] },
        { fCode: 'MM02', fDes: 'Vibração / estabilidade', subCodes: [] },
        { fCode: 'MM03', fDes: 'Partido / rasgado / esfarelado / quebrado', subCodes: [] },
        { fCode: 'MM04', fDes: 'Danos de transporte', subCodes: [] },
        { fCode: 'MM05', fDes: 'Posicionamento do componente incorreto / solto', subCodes: [] },
        { fCode: 'MM07', fDes: 'Danos na superfície: pintura, esmalte, vidro', subCodes: [] },
        { fCode: 'MM08', fDes: 'Dobrado / deformado / empenado', subCodes: [] },
        { fCode: 'MM10', fDes: 'Encravado / preso', subCodes: [] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [] },
        { fCode: 'ZZ01', fDes: 'Demasiado alto / ruído', subCodes: [] },
        { fCode: 'ZZ02', fDes: 'Instalação ou ligação inadequada', subCodes: [] },
        { fCode: 'ZZ03', fDes: 'Utilização inadequada pelo utilizador', subCodes: [] },
        { fCode: 'ZZ05', fDes: 'Avaria não se verificou durante a visita do técnico', subCodes: [] },
        { fCode: 'ZZ06', fDes: 'Falta de clareza / erro grave no manual do utilizador', subCodes: [] },
        { fCode: 'ZZ07', fDes: 'Odor / Cheiro', subCodes: [] },
        { fCode: 'ZZ08', fDes: 'Oxidação / corrosão', subCodes: [] },
        { fCode: 'ZZ09', fDes: 'Fogo', subCodes: [] },
        { fCode: 'ZZ10', fDes: 'Componente em falta', subCodes: [] },
        { fCode: 'ZZ11', fDes: 'Cancelado / Resolvido telefonicamente', subCodes: [] },
        { fCode: 'ZZ12', fDes: 'Equipamento não cumpre as expectativas do cliente', subCodes: [] },
        { fCode: 'ZZ13', fDes: 'Reparação indesejável', subCodes: [] },
        { fCode: 'ZZ14', fDes: 'Equipamento recolhido / devolvido', subCodes: [] },
        { fCode: 'ZZ16', fDes: 'Cor difere de equipamento de outra marca', subCodes: [] },
        { fCode: 'ZZ19', fDes: 'Tolerância de dimensão anómala', subCodes: [] },
        { fCode: 'ZZ20', fDes: 'Não fecha bem / porta não veda', subCodes: [] },
        { fCode: 'ZZ21', fDes: 'Alteração de cor', subCodes: [] },
        { fCode: 'ZZ22', fDes: 'Ajuste / calibração', subCodes: [] },
        { fCode: 'ZZ24', fDes: 'Arestas vivas / cortantes', subCodes: [] },
        { fCode: 'ZZ25', fDes: 'Superfície derretida do móvel de cozinha', subCodes: [] },
        { fCode: 'ZZ27', fDes: 'Abastecimento de gás deficiente', subCodes: [] },
        { fCode: 'ZZ28', fDes: 'Danos durante ou após a instalação', subCodes: [] },
        { fCode: 'ZZ46', fDes: 'Cliente não estava em casa', subCodes: [] },
        { fCode: 'ZZ48', fDes: 'Contaminação / obstrução durante o fabrico', subCodes: [] },
        { fCode: 'ZZ49', fDes: 'Reparação incorreta na última visita', subCodes: [] },
        { fCode: 'ZZ50', fDes: 'Conselho de limpeza fornecido ao cliente', subCodes: [] },
        { fCode: 'ZZ51', fDes: 'Relatório após aprovação', subCodes: [] },
        { fCode: 'ZZ52', fDes: 'Código FD obsoleto (Sem culpa)', subCodes: [] },
        { fCode: 'ZZ54', fDes: 'Expectativa errada do cliente', subCodes: [] },
        { fCode: 'ZZ57', fDes: 'Nova visita; inacessível para reparação', subCodes: [] },
        { fCode: 'ZZ58', fDes: 'Nova visita; recebido danificado ou defeituoso', subCodes: [] },
        { fCode: 'ZZ59', fDes: 'Nova visita; descrição incorreta da avaria', subCodes: [] },
        { fCode: 'ZZ60', fDes: 'Nova visita; modelo errado', subCodes: [] },
        { fCode: 'ZZ61', fDes: 'Nova visita; peças erradas ou em falta', subCodes: [] },
        { fCode: 'ZZ62', fDes: 'Nova visita; sem ferramentas / sem documentação', subCodes: [] },
        { fCode: 'ZZ64', fDes: 'Instruções de utilização ou instalação em falta', subCodes: [] },
        { fCode: 'ZZ65', fDes: 'Ambiente / instalação inadequada', subCodes: [] },
        { fCode: 'ZZ66', fDes: 'Instrução e esclarecimento do cliente', subCodes: [] },
    ],
    FF1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [{ sCode: '111', sDes: 'Sem alimentação / Não liga' }, { sCode: '11A', sDes: 'Dá sinal/Liga mas não funciona' }, { sCode: '11C', sDes: 'Dispara fusível externo (rede)' }, { sCode: '11F', sDes: 'Não funciona' }, { sCode: '11H', sDes: 'Disjuntor de proteção interno dispara' }] },
        { fCode: '120', fDes: 'Problema de carga / Problema de nível', subCodes: [{ sCode: '124', sDes: 'Aquecimento / temperatura insuficiente' }, { sCode: '125', sDes: 'Aquecimento / temperatura excessiva' }, { sCode: '126', sDes: 'Arrefecimento insuficiente (não específico)' }, { sCode: '127', sDes: 'Arrefecimento excessivo (não específico)' }, { sCode: '12A1', sDes: 'Atraso na água' }, { sCode: '12A2', sDes: 'Fluxo de água prolongado' }] },
        { fCode: '130', fDes: 'Problema na função de visualização / ecrã', subCodes: [{ sCode: '131', sDes: 'Ecrã sem imagem ou com falhas' }, { sCode: '132', sDes: 'Funcionamento deficiente da lâmpada / LED' }, { sCode: '134', sDes: 'Funcionamento deficiente dos menus no ecrã' }, { sCode: '138', sDes: 'Visualização de alarme / erro com falha' }] },
        { fCode: '140', fDes: 'Ruído anómalo', subCodes: [{ sCode: '149', sDes: 'Estalidos' }, { sCode: '14A', sDes: 'Assobio' }, { sCode: '14B', sDes: 'Borbulhar, ebulição' }, { sCode: '14F', sDes: 'Chiar / Ruído agudo' }, { sCode: '14G', sDes: 'Ruído de fricção / trituração' }, { sCode: '14I', sDes: 'Ruído de bombagem' }, { sCode: '14X', sDes: 'Outro tipo de ruído anómalo' }] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [{ sCode: '161', sDes: 'Chassis / painel danificado ou deformado' }, { sCode: '162', sDes: 'Puxador / clipe / cinta de transporte danificada' }, { sCode: '163', sDes: 'Manípulo(s) de controlo / botão(ões) danificado(s)' }, { sCode: '164', sDes: 'Porta / tampa danificada' }, { sCode: '165', sDes: 'Vedante / junta danificada' }, { sCode: '16B', sDes: 'Componente ou peça decorativa em falta' }, { sCode: '16D', sDes: 'Equipamento a queimar / emite fumo' }, { sCode: '16E', sDes: 'Danos na superfície externa' }, { sCode: '16G', sDes: 'Suporte fraco / danificado' }, { sCode: '16J', sDes: 'Equipamento aquece muito / peças a derreter' }, { sCode: '16L', sDes: 'Marcas de queimado' }, { sCode: '16N', sDes: 'Cabo de alimentação danificado' }, { sCode: '16P', sDes: 'Acessório danificado' }] },
        { fCode: '170', fDes: 'Problema de funcionamento geral', subCodes: [{ sCode: '175', sDes: 'Problema de programação / ajuste do utilizador' }, { sCode: '17O', sDes: 'Sem iluminação interior' }, { sCode: '17S', sDes: 'Temperatura não ajustável' }] },
        { fCode: '180', fDes: 'Requisitos especiais', subCodes: [{ sCode: '187', sDes: 'Acessório errado ou em falta' }] },
        { fCode: '190', fDes: 'Odor / Cheiro', subCodes: [{ sCode: '190', sDes: 'Odor / Cheiro' }] },
        { fCode: '650', fDes: 'Instabilidade mecânica', subCodes: [{ sCode: '655', sDes: 'Defeito na roda / rodízio' }] },
        { fCode: '690', fDes: 'Porta / tampa danificada', subCodes: [{ sCode: '693', sDes: 'Porta não fecha corretamente' }, { sCode: '694', sDes: 'Porta não abre / muito pesada para abrir' }, { sCode: '695', sDes: 'Borracha da porta danificada' }, { sCode: '696', sDes: 'Aro da porta danificado' }, { sCode: '697', sDes: 'Vidro da porta danificado' }, { sCode: '698', sDes: 'Porta cai' }, { sCode: '69A', sDes: 'Porta desalinhada / inclinada' }, { sCode: '69B', sDes: 'Dobradiça danificada' }] },
        { fCode: 'B10', fDes: 'Não funciona / Sem função', subCodes: [{ sCode: 'B11', sDes: 'Não arrefece' }, { sCode: 'B12', sDes: 'Não congela' }, { sCode: 'B13', sDes: 'Não aquece' }, { sCode: 'B16', sDes: 'Não descongela' }, { sCode: 'B1A', sDes: 'Não produz gelo' }, { sCode: 'B1B', sDes: 'Não produz gelo picado' }, { sCode: 'B1C', sDes: 'Não produz água fria' }, { sCode: 'B1X', sDes: 'Outro problema de falta de função' }] },
        { fCode: 'B20', fDes: 'Problema operacional', subCodes: [{ sCode: 'B22', sDes: 'Congelação insuficiente' }, { sCode: 'B26', sDes: 'Congelação excessiva' }, { sCode: 'B2C', sDes: 'Compressor sempre a funcionar' }] },
        { fCode: 'B30', fDes: 'Desempenho deficiente de refrigeração / aquecimento', subCodes: [{ sCode: 'B34', sDes: 'Qualidade dos cubos de gelo insuficiente' }] },
        { fCode: 'B40', fDes: 'Problema de água / gelo / ruído', subCodes: [{ sCode: 'B41', sDes: 'Condensação no interior do chassis' }, { sCode: 'B42', sDes: 'Acumulação excessiva de gelo' }, { sCode: 'B44', sDes: 'Água no interior do chassis' }, { sCode: 'B45', sDes: 'Compressor ruidoso' }, { sCode: 'B46', sDes: 'Interruptor magnético ruidoso' }] },
        { fCode: 'B50', fDes: 'Fuga', subCodes: [{ sCode: 'B51', sDes: 'Fuga de combustível / óleo' }, { sCode: 'B53', sDes: 'Emissão de fumo' }, { sCode: 'B54', sDes: 'Fuga de água' }] },
        { fCode: 'B60', fDes: 'Peças danificadas', subCodes: [{ sCode: 'B61', sDes: 'Evaporador danificado' }, { sCode: 'B62', sDes: 'Ajuste de temperatura encravado' }] },
        { fCode: 'PC', fDes: 'Recolha de Produto Defeituoso', subCodes: [{ sCode: 'PC', sDes: 'Recolha de Produto Defeituoso' }] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [{ sCode: 'Y4', sDes: 'Instalação do produto' }] },
    ],
    KA1: [
        { fCode: 'EE01', fDes: 'Exibe modo Showroom / modo de teste', subCodes: [] },
        { fCode: 'EE02', fDes: 'Cablagem incorreta', subCodes: [] },
        { fCode: 'EE03', fDes: 'Curto-circuito', subCodes: [] },
        { fCode: 'EE04', fDes: 'Componente não liga', subCodes: [] },
        { fCode: 'EE05', fDes: 'Componente não desliga', subCodes: [] },
        { fCode: 'EE06', fDes: 'Mau contacto elétrico solto', subCodes: [] },
        { fCode: 'EE07', fDes: 'Mau contacto', subCodes: [] },
        { fCode: 'EE08', fDes: 'Contacto queimado / incandescente / derretido', subCodes: [] },
        { fCode: 'EE09', fDes: 'Descarga atmosférica / raio', subCodes: [] },
        { fCode: 'EE10', fDes: 'Cablagem danificada', subCodes: [] },
        { fCode: 'EE11', fDes: 'Software bloqueado (reconfigurável)', subCodes: [] },
        { fCode: 'EE12', fDes: 'Para durante o programa', subCodes: [] },
        { fCode: 'EE13', fDes: 'Fagulhas / faíscas incorretas', subCodes: [] },
        { fCode: 'EE14', fDes: 'Oscilação da tensão de rede', subCodes: [] },
        { fCode: 'EE15', fDes: 'Componente abre sozinho involuntariamente', subCodes: [] },
        { fCode: 'EE17', fDes: 'Hora incorreta', subCodes: [] },
        { fCode: 'EE20', fDes: 'Ecrã com leitura difícil / cor errada', subCodes: [] },
        { fCode: 'EE27', fDes: 'Elemento mal fixado', subCodes: [] },
        { fCode: 'EE29', fDes: 'Atualização de software', subCodes: [] },
        { fCode: 'EE30', fDes: 'Fagulhas no interior do forno', subCodes: [] },
        { fCode: 'EE31', fDes: 'Relógio adianta / atrasa', subCodes: [] },
        { fCode: 'FC06', fDes: 'Fuga de água / vedação deficiente', subCodes: [] },
        { fCode: 'FC07', fDes: 'Não mete água (gerador de vapor)', subCodes: [] },
        { fCode: 'FD01', fDes: 'Secagem deficiente', subCodes: [] },
        { fCode: 'FF02', fDes: 'Lavagem / enxaguamento deficiente', subCodes: [] },
        { fCode: 'FF05', fDes: 'Desempenho de cozedura deficiente', subCodes: [] },
        { fCode: 'FF06', fDes: 'Formação de gotas / condensação', subCodes: [] },
        { fCode: 'FF07', fDes: 'Queima / combustão', subCodes: [] },
        { fCode: 'FF08', fDes: 'Gás não acendeu', subCodes: [] },
        { fCode: 'FF09', fDes: 'Gás apaga-se', subCodes: [] },
        { fCode: 'FF11', fDes: 'Liga/desliga automaticamente por si só', subCodes: [] },
        { fCode: 'FF12', fDes: 'Configuração do equipamento', subCodes: [] },
        { fCode: 'FF13', fDes: 'Sem deteção de recipiente na placa de indução', subCodes: [] },
        { fCode: 'FF14', fDes: 'Temperatura demasiado alta', subCodes: [] },
        { fCode: 'FF15', fDes: 'Temperatura demasiado baixa', subCodes: [] },
        { fCode: 'FF16', fDes: 'Funcionamento preso / duro', subCodes: [] },
        { fCode: 'FF17', fDes: 'Acumulação de água', subCodes: [] },
        { fCode: 'FF18', fDes: 'Water level failure', subCodes: [] },
        { fCode: 'GG01', fDes: 'Queimado / explodido / incandescente', subCodes: [] },
        { fCode: 'GG02', fDes: 'Gás errado / conversão para outro tipo de gás', subCodes: [] },
        { fCode: 'GG03', fDes: 'Pressão errada', subCodes: [] },
        { fCode: 'GG04', fDes: 'Ajuste / calibração', subCodes: [] },
        { fCode: 'GG05', fDes: 'Fuga de gás', subCodes: [] },
        { fCode: 'GG06', fDes: 'Configuração errada em fábrica', subCodes: [] },
        { fCode: 'MM01', fDes: 'Corpo estranho', subCodes: [] },
        { fCode: 'MM02', fDes: 'Vibração / estabilidade', subCodes: [] },
        { fCode: 'MM03', fDes: 'Partido / rasgado / esfarelado / quebrado', subCodes: [] },
        { fCode: 'MM04', fDes: 'Danos de transporte', subCodes: [] },
        { fCode: 'MM05', fDes: 'Posicionamento do componente incorreto / solto', subCodes: [] },
        { fCode: 'MM07', fDes: 'Danos na superfície: pintura, esmalte, vidro', subCodes: [] },
        { fCode: 'MM08', fDes: 'Dobrado / deformado / empenado', subCodes: [] },
        { fCode: 'MM10', fDes: 'Encravado / preso', subCodes: [] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [] },
        { fCode: 'ZZ01', fDes: 'Demasiado alto / ruído', subCodes: [] },
        { fCode: 'ZZ02', fDes: 'Instalação ou ligação inadequada', subCodes: [] },
        { fCode: 'ZZ03', fDes: 'Utilização inadequada pelo utilizador', subCodes: [] },
        { fCode: 'ZZ05', fDes: 'Avaria não se verificou durante a visita do técnico', subCodes: [] },
        { fCode: 'ZZ06', fDes: 'Falta de clareza / erro grave no manual do utilizador', subCodes: [] },
        { fCode: 'ZZ07', fDes: 'Odor / Cheiro', subCodes: [] },
        { fCode: 'ZZ08', fDes: 'Oxidação / corrosão', subCodes: [] },
        { fCode: 'ZZ09', fDes: 'Fogo', subCodes: [] },
        { fCode: 'ZZ10', fDes: 'Componente em falta', subCodes: [] },
        { fCode: 'ZZ11', fDes: 'Cancelado / Resolvido telefonicamente', subCodes: [] },
        { fCode: 'ZZ12', fDes: 'Equipamento não cumpre as expectativas do cliente', subCodes: [] },
        { fCode: 'ZZ13', fDes: 'Reparação indesejável', subCodes: [] },
        { fCode: 'ZZ14', fDes: 'Equipamento recolhido / devolvido', subCodes: [] },
        { fCode: 'ZZ16', fDes: 'Cor difere de equipamento de outra marca', subCodes: [] },
        { fCode: 'ZZ19', fDes: 'Tolerância de dimensão anómala', subCodes: [] },
        { fCode: 'ZZ20', fDes: 'Não fecha bem / porta não veda', subCodes: [] },
        { fCode: 'ZZ21', fDes: 'Alteração de cor', subCodes: [] },
        { fCode: 'ZZ22', fDes: 'Ajuste / calibração', subCodes: [] },
        { fCode: 'ZZ24', fDes: 'Arestas vivas / cortantes', subCodes: [] },
        { fCode: 'ZZ25', fDes: 'Superfície derretida do móvel de cozinha', subCodes: [] },
        { fCode: 'ZZ27', fDes: 'Abastecimento de gás deficiente', subCodes: [] },
        { fCode: 'ZZ28', fDes: 'Danos durante ou após a instalação', subCodes: [] },
        { fCode: 'ZZ46', fDes: 'Cliente não estava em casa', subCodes: [] },
        { fCode: 'ZZ48', fDes: 'Contaminação / obstrução durante o fabrico', subCodes: [] },
        { fCode: 'ZZ49', fDes: 'Reparação incorreta na última visita', subCodes: [] },
        { fCode: 'ZZ50', fDes: 'Conselho de limpeza fornecido ao cliente', subCodes: [] },
        { fCode: 'ZZ51', fDes: 'Relatório após aprovação', subCodes: [] },
        { fCode: 'ZZ52', fDes: 'Código FD obsoleto (Sem culpa)', subCodes: [] },
        { fCode: 'ZZ54', fDes: 'Expectativa errada do cliente', subCodes: [] },
        { fCode: 'ZZ57', fDes: 'Nova visita; inacessível para reparação', subCodes: [] },
        { fCode: 'ZZ58', fDes: 'Nova visita; recebido danificado ou defeituoso', subCodes: [] },
        { fCode: 'ZZ59', fDes: 'Nova visita; descrição incorreta da avaria', subCodes: [] },
        { fCode: 'ZZ60', fDes: 'Nova visita; modelo errado', subCodes: [] },
        { fCode: 'ZZ61', fDes: 'Nova visita; peças erradas ou em falta', subCodes: [] },
        { fCode: 'ZZ62', fDes: 'Nova visita; sem ferramentas / sem documentação', subCodes: [] },
        { fCode: 'ZZ64', fDes: 'Instruções de utilização ou instalação em falta', subCodes: [] },
        { fCode: 'ZZ65', fDes: 'Ambiente / instalação inadequada', subCodes: [] },
        { fCode: 'ZZ66', fDes: 'Instrução e esclarecimento do cliente', subCodes: [] },
    ],
    LS1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [] },
        { fCode: '130', fDes: 'Problema na função de visualização / ecrã', subCodes: [] },
        { fCode: '150', fDes: 'Problema no controlo remoto / comando', subCodes: [] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [] },
        { fCode: '163', fDes: 'Problema nos botões', subCodes: [] },
        { fCode: '168', fDes: 'Problema de aparência', subCodes: [] },
        { fCode: '210', fDes: 'Sem receção ou sem ligação', subCodes: [] },
        { fCode: '310', fDes: 'Sem imagem', subCodes: [] },
        { fCode: '330', fDes: 'Problema de qualidade de imagem', subCodes: [] },
        { fCode: '342', fDes: 'Pontos brancos visíveis na imagem', subCodes: [] },
        { fCode: '410', fDes: 'Sem cor', subCodes: [] },
        { fCode: '430', fDes: 'Qualidade de cor deficiente', subCodes: [] },
        { fCode: '510', fDes: 'Sem áudio', subCodes: [] },
        { fCode: '530', fDes: 'Qualidade do áudio', subCodes: [] },
        { fCode: '610', fDes: 'Problema de interface', subCodes: [] },
        { fCode: '710', fDes: 'Falha no reconhecimento do cartão B-CAS', subCodes: [] },
        { fCode: '720', fDes: 'Não é possível identificar o disco rígido (HDD)', subCodes: [] },
        { fCode: '730', fDes: 'Não liga à rede', subCodes: [] },
        { fCode: '740', fDes: 'Não abre/opera o menu do sistema', subCodes: [] },
        { fCode: '750', fDes: 'Ruidoso', subCodes: [] },
        { fCode: '760', fDes: 'Sobreaquecimento', subCodes: [] },
        { fCode: '770', fDes: 'Odor / Cheiro', subCodes: [] },
        { fCode: '780', fDes: 'Receção de sinal fraca', subCodes: [] },
        { fCode: '790', fDes: 'Receção BS fraca', subCodes: [] },
        { fCode: '810', fDes: 'Gravação anómala', subCodes: [] },
        { fCode: '820', fDes: 'EPG (Guia de Programas) anómalo', subCodes: [] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [] },
        { fCode: 'Z00', fDes: 'Outros problemas', subCodes: [] },
    ],
    MP1: [
        { fCode: '110', fDes: 'Ligar/desligar ou não funciona', subCodes: [] },
        { fCode: '120', fDes: 'Problema com carregador de bateria', subCodes: [] },
        { fCode: '210', fDes: 'Problema ao efetuar/receber chamadas', subCodes: [] },
        { fCode: '220', fDes: 'Telemóvel congelado / bloqueado', subCodes: [] },
        { fCode: '310', fDes: 'Problema em função principal', subCodes: [] },
        { fCode: '320', fDes: 'Problema no painel tátil LCD/LED', subCodes: [] },
        { fCode: '330', fDes: 'Problema de rede', subCodes: [] },
        { fCode: '340', fDes: 'Problema no cartão SIM/UIM', subCodes: [] },
        { fCode: '350', fDes: 'Problema na câmara', subCodes: [] },
        { fCode: '410', fDes: 'Problema de aparência', subCodes: [] },
        { fCode: '510', fDes: 'Problema de áudio/som/altifalante', subCodes: [] },
        { fCode: '610', fDes: 'Problema de software do sistema operativo', subCodes: [] },
        { fCode: 'Z00', fDes: 'Outros problemas', subCodes: [] },
    ],
    PAD: [
        { fCode: '110', fDes: 'Problema de energia ou ao ligar/desligar', subCodes: [] },
        { fCode: '120', fDes: 'Não carrega', subCodes: [] },
        { fCode: '210', fDes: 'Problema de funcionamento', subCodes: [] },
        { fCode: '220', fDes: 'Problema no painel tátil (Touch)', subCodes: [] },
        { fCode: '230', fDes: 'Painel LCD/LED partido ou riscado', subCodes: [] },
        { fCode: '240', fDes: 'Sem ecrã ou imagem com falhas', subCodes: [] },
        { fCode: '250', fDes: 'Ecrã totalmente preto ou branco', subCodes: [] },
        { fCode: '260', fDes: 'Linhas, barras ou pontos no ecrã', subCodes: [] },
        { fCode: '310', fDes: 'Problema de conectividade Wi-Fi', subCodes: [] },
        { fCode: '320', fDes: 'Problema no cartão SD', subCodes: [] },
        { fCode: '330', fDes: 'Problema na câmara', subCodes: [] },
        { fCode: '340', fDes: 'Problema em HDMI', subCodes: [] },
        { fCode: '350', fDes: 'Entrada USB ou cabo com defeito', subCodes: [] },
        { fCode: '360', fDes: 'Problema nos botões de energia ou volume', subCodes: [] },
        { fCode: '410', fDes: 'Problema de aparência', subCodes: [] },
        { fCode: '420', fDes: 'Problema de bateria/carregador', subCodes: [] },
        { fCode: '510', fDes: 'Problema de áudio/som/altifalante', subCodes: [] },
        { fCode: '610', fDes: 'Problema com aplicação (APP)', subCodes: [] },
        { fCode: '620', fDes: 'Sistema parado / Sem resposta', subCodes: [] },
        { fCode: 'Z00', fDes: 'Outros problemas', subCodes: [] },
    ],
    POS: [
        { fCode: 'BLSC', fDes: 'Ecrã em branco', subCodes: [] },
        { fCode: 'FRZS', fDes: 'Unidade congela / bloqueia', subCodes: [] },
        { fCode: 'LINE', fDes: 'Linhas no ecrã', subCodes: [] },
        { fCode: 'MMDF', fDes: 'Falha causada pelo utilizador', subCodes: [] },
        { fCode: 'NCAL', fDes: 'Impossível calibrar', subCodes: [] },
        { fCode: 'NDIS', fDes: 'Sem imagem / ecrã apagado', subCodes: [] },
        { fCode: 'NSWI', fDes: 'Não liga', subCodes: [] },
        { fCode: 'NSYS', fDes: 'Sistema operativo instável / com defeito', subCodes: [] },
        { fCode: 'OTHR', fDes: 'Outros', subCodes: [] },
        { fCode: 'RBTS', fDes: 'Reinicia sozinho', subCodes: [] },
        { fCode: 'SCBL', fDes: 'Ecrã azul', subCodes: [] },
        { fCode: 'SCJP', fDes: 'Imagem aos saltos', subCodes: [] },
        { fCode: 'SWOF', fDes: 'Desliga-se sozinho', subCodes: [] },
        { fCode: 'TCFL', fDes: 'Função tátil com falha', subCodes: [] },
    ],
    RF1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [{ sCode: '111', sDes: 'Sem alimentação / Não liga' }, { sCode: '11A', sDes: 'Dá sinal/Liga mas não funciona' }, { sCode: '11C', sDes: 'Dispara fusível externo (rede)' }, { sCode: '11F', sDes: 'Não funciona' }, { sCode: '11H', sDes: 'Disjuntor de proteção interno dispara' }] },
        { fCode: '120', fDes: 'Problema de carga / Problema de nível', subCodes: [{ sCode: '124', sDes: 'Aquecimento / temperatura insuficiente' }, { sCode: '125', sDes: 'Aquecimento / temperatura excessiva' }, { sCode: '126', sDes: 'Arrefecimento insuficiente (não específico)' }, { sCode: '127', sDes: 'Arrefecimento excessivo (não específico)' }, { sCode: '12A1', sDes: 'Atraso na água' }, { sCode: '12A2', sDes: 'Fluxo de água prolongado' }] },
        { fCode: '130', fDes: 'Problema na função de visualização / ecrã', subCodes: [{ sCode: '131', sDes: 'Ecrã sem imagem ou com falhas' }, { sCode: '132', sDes: 'Funcionamento deficiente da lâmpada / LED' }, { sCode: '134', sDes: 'Funcionamento deficiente dos menus no ecrã' }, { sCode: '138', sDes: 'Visualização de alarme / erro com falha' }] },
        { fCode: '140', fDes: 'Ruído anómalo', subCodes: [{ sCode: '149', sDes: 'Estalidos' }, { sCode: '14A', sDes: 'Assobio' }, { sCode: '14B', sDes: 'Borbulhar, ebulição' }, { sCode: '14F', sDes: 'Chiar / Ruído agudo' }, { sCode: '14G', sDes: 'Ruído de fricção / trituração' }, { sCode: '14I', sDes: 'Ruído de bombagem' }, { sCode: '14X', sDes: 'Outro tipo de ruído anómalo' }] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [{ sCode: '161', sDes: 'Chassis / painel danificado ou deformado' }, { sCode: '162', sDes: 'Puxador / clipe / cinta de transporte danificada' }, { sCode: '163', sDes: 'Manípulo(s) de controlo / botão(ões) danificado(s)' }, { sCode: '164', sDes: 'Porta / tampa danificada' }, { sCode: '165', sDes: 'Vedante / junta danificada' }, { sCode: '16B', sDes: 'Componente ou peça decorativa em falta' }, { sCode: '16D', sDes: 'Equipamento a queimar / emite fumo' }, { sCode: '16E', sDes: 'Danos na superfície externa' }, { sCode: '16G', sDes: 'Suporte fraco / danificado' }, { sCode: '16J', sDes: 'Equipamento aquece muito / peças a derreter' }, { sCode: '16L', sDes: 'Marcas de queimado' }, { sCode: '16N', sDes: 'Cabo de alimentação danificado' }, { sCode: '16P', sDes: 'Acessório danificado' }] },
        { fCode: '170', fDes: 'Problema de funcionamento geral', subCodes: [{ sCode: '175', sDes: 'Problema de programação / ajuste do utilizador' }, { sCode: '17O', sDes: 'Sem iluminação interior' }, { sCode: '17S', sDes: 'Temperatura não ajustável' }] },
        { fCode: '180', fDes: 'Requisitos especiais', subCodes: [{ sCode: '187', sDes: 'Acessório errado ou em falta' }] },
        { fCode: '190', fDes: 'Odor / Cheiro', subCodes: [{ sCode: '190', sDes: 'Odor / Cheiro' }] },
        { fCode: '650', fDes: 'Instabilidade mecânica', subCodes: [{ sCode: '655', sDes: 'Defeito na roda / rodízio' }] },
        { fCode: '690', fDes: 'Porta / tampa danificada', subCodes: [{ sCode: '693', sDes: 'Porta não fecha corretamente' }, { sCode: '694', sDes: 'Porta não abre / muito pesada para abrir' }, { sCode: '695', sDes: 'Borracha da porta danificada' }, { sCode: '696', sDes: 'Aro da porta danificado' }, { sCode: '697', sDes: 'Vidro da porta danificado' }, { sCode: '698', sDes: 'Porta cai' }, { sCode: '69A', sDes: 'Porta desalinhada / inclinada' }, { sCode: '69B', sDes: 'Dobradiça danificada' }] },
        { fCode: 'B10', fDes: 'Não funciona / Sem função', subCodes: [{ sCode: 'B11', sDes: 'Não arrefece' }, { sCode: 'B12', sDes: 'Não congela' }, { sCode: 'B13', sDes: 'Não aquece' }, { sCode: 'B16', sDes: 'Não descongela' }, { sCode: 'B1A', sDes: 'Não produz gelo' }, { sCode: 'B1B', sDes: 'Não produz gelo picado' }, { sCode: 'B1C', sDes: 'Não produz água fria' }, { sCode: 'B1X', sDes: 'Outro problema de falta de função' }] },
        { fCode: 'B20', fDes: 'Problema operacional', subCodes: [{ sCode: 'B22', sDes: 'Congelação insuficiente' }, { sCode: 'B26', sDes: 'Congelação excessiva' }, { sCode: 'B2C', sDes: 'Compressor sempre a funcionar' }] },
        { fCode: 'B30', fDes: 'Desempenho deficiente de refrigeração / aquecimento', subCodes: [{ sCode: 'B34', sDes: 'Qualidade dos cubos de gelo insuficiente' }] },
        { fCode: 'B40', fDes: 'Problema de água / gelo / ruído', subCodes: [{ sCode: 'B41', sDes: 'Condensação no interior do chassis' }, { sCode: 'B42', sDes: 'Acumulação excessiva de gelo' }, { sCode: 'B44', sDes: 'Água no interior do chassis' }, { sCode: 'B45', sDes: 'Compressor ruidoso' }, { sCode: 'B46', sDes: 'Interruptor magnético ruidoso' }] },
        { fCode: 'B50', fDes: 'Fuga', subCodes: [{ sCode: 'B51', sDes: 'Fuga de combustível / óleo' }, { sCode: 'B53', sDes: 'Emissão de fumo' }, { sCode: 'B54', sDes: 'Fuga de água' }] },
        { fCode: 'B60', fDes: 'Peças danificadas', subCodes: [{ sCode: 'B61', sDes: 'Evaporador danificado' }, { sCode: 'B62', sDes: 'Ajuste de temperatura encravado' }] },
        { fCode: 'PC', fDes: 'Recolha de Produto Defeituoso', subCodes: [{ sCode: 'PC', sDes: 'Recolha de Produto Defeituoso' }] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [{ sCode: 'Y4', sDes: 'Instalação do produto' }] },
    ],
    SH1: [
        { fCode: 'C10', fDes: 'Lâmpada acende, mas o produto não funciona', subCodes: [] },
        { fCode: 'C11', fDes: 'Lâmpada não acende e o produto não funciona', subCodes: [] },
        { fCode: 'C12', fDes: 'Ecrã / visualização anómala', subCodes: [] },
        { fCode: 'C20', fDes: 'Não aquece', subCodes: [] },
        { fCode: 'C30', fDes: 'Desliga-se a meio do programa', subCodes: [] },
        { fCode: 'C31', fDes: 'Falha no temporizador / modo horário', subCodes: [] },
        { fCode: 'C32', fDes: 'O prato rotativo não gira', subCodes: [] },
        { fCode: 'C33', fDes: 'Fuga de micro-ondas', subCodes: [] },
        { fCode: 'C40', fDes: 'A lâmpada não acende', subCodes: [] },
        { fCode: 'C50', fDes: 'Ruído anómalo', subCodes: [] },
        { fCode: 'C60', fDes: 'Fuga de eletricidade / passagem', subCodes: [] },
        { fCode: 'C70', fDes: 'Aparência e estrutura', subCodes: [] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [] },
    ],
    TV1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [{ sCode: '111', sDes: 'Sem Alimentação / Não liga' }, { sCode: '1140', sDes: 'Bloqueado no LOGO / Congelado' }, { sCode: '119', sDes: 'Não sai do modo standby / espera' }, { sCode: '11B', sDes: 'Ciclo intermitente de ligar/desligar' }, { sCode: '11D', sDes: 'Desliga-se sozinho' }, { sCode: '11K', sDes: 'Arranque inicial demasiado lento' }, { sCode: '11X', sDes: 'Outro problema de energia' }, { sCode: '12A3', sDes: 'Não liga após atualização OTA' }, { sCode: '35A', sDes: 'Imagem / ecrã congelado' }] },
        { fCode: '150', fDes: 'Problema no controlo remoto / comando', subCodes: [{ sCode: '151', sDes: 'Controlo remoto não funciona' }, { sCode: '152', sDes: 'Resposta incorreta do comando' }, { sCode: '153', sDes: 'Problema de programação / aprendizagem do comando' }, { sCode: '154', sDes: 'Fraca sensibilidade do controlo remoto' }, { sCode: '1550', sDes: 'Assistente de voz não funciona' }, { sCode: '1590', sDes: 'Função de voz inteligente não funciona' }, { sCode: 'T156', sDes: 'Controlo remoto não emparelha / incompatível' }, { sCode: 'T157', sDes: 'Tecla do comando presa' }, { sCode: 'T158', sDes: 'Emparelhamento Bluetooth do comando anómalo' }] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [{ sCode: '161', sDes: 'Tampa / carcaça danificada ou deformada' }, { sCode: '1620', sDes: 'Ecrã / painel curvado' }, { sCode: '164', sDes: 'Ecrã descolado do chassis' }, { sCode: '1650', sDes: 'Painel empenado / a cair' }, { sCode: '166', sDes: 'Ficha/Porta/Conector/Ranhura de cartões danificada' }, { sCode: '1680', sDes: 'LOGO da tampa frontal incorreto' }, { sCode: '16A1', sDes: 'Ecrã / painel danificado' }, { sCode: '16A2', sDes: 'Ecrã / painel riscado' }, { sCode: '16A3', sDes: 'Folga na tampa / chassis' }, { sCode: '16A4', sDes: 'Embalagem danificada' }, { sCode: '16A5', sDes: 'Manípulo/Botão/Teclado danificado' }, { sCode: '16D', sDes: 'TV a queimar / Fumo / Fogo' }, { sCode: '16F', sDes: 'Cheiro estranho / peculiar' }, { sCode: '16J', sDes: 'TV muito quente / componentes a derreter' }, { sCode: '16K', sDes: 'Corpo estranho no ecrã' }, { sCode: '16N', sDes: 'Cabo de alimentação danificado' }, { sCode: '16W', sDes: 'Material estranho (fora da TV)' }] },
        { fCode: '170', fDes: 'Problema de funcionamento geral', subCodes: [{ sCode: '17A1', sDes: 'Menu do sistema inacessível / não funciona' }, { sCode: '17D', sDes: 'Idioma incorreto / conjunto de caracteres do LOGO com erro' }, { sCode: '17N', sDes: 'Problema na função do menu' }, { sCode: '21A3', sDes: 'Edição de canais anómala' }, { sCode: '21A4', sDes: 'Gravação com anomalia' }] },
        { fCode: 'A120', fDes: 'Problema na função de aplicação (APP)', subCodes: [{ sCode: '12A1', sDes: 'Aplicação fecha sozinha' }, { sCode: '12A2', sDes: 'Aplicação congelada / bloqueada' }, { sCode: '12A3', sDes: 'Não liga após atualização OTA' }, { sCode: '12A4', sDes: 'Funcionamento anómalo após atualização OTA' }, { sCode: '12A5', sDes: 'Falha no download da OTA' }, { sCode: '12A7', sDes: 'Aplicação com funcionamento anómalo' }, { sCode: '12A8', sDes: 'Reprodução de vídeo online congelada' }, { sCode: '12B2', sDes: 'Navegador com funcionamento anómalo' }, { sCode: '21A2', sDes: 'Rede / Wi-Fi indisponível' }, { sCode: '781', sDes: 'Problema na interface USB' }] },
        { fCode: 'A210', fDes: 'Sem receção / Problema de ligação', subCodes: [{ sCode: '12A5', sDes: 'Falha no download da OTA' }, { sCode: '216', sDes: 'Sem sinal BS/CS' }, { sCode: '217', sDes: 'Sem sinal CS' }, { sCode: '218', sDes: 'Sem sinal de TV' }, { sCode: '21A1', sDes: 'AV/VGA/HDMI não funcionam' }, { sCode: '21A2', sDes: 'Rede / Wi-Fi indisponível' }] },
        { fCode: 'A310', fDes: 'Problema de imagem / ecrã / visualização', subCodes: [{ sCode: '16K', sDes: 'Corpo estranho no ecrã' }, { sCode: '3120', sDes: 'Ponto brilhante/preto/cor no ecrã (Pixel)' }, { sCode: '3130', sDes: 'TV mostra estado "M" (Modo Fábrica)' }, { sCode: '3140', sDes: 'Ecrã queimado / Burn-in' }, { sCode: '3150', sDes: 'Ecrã sujo' }, { sCode: '3160', sDes: 'Derrame de líquido do painel' }, { sCode: '3170', sDes: 'Desfasamento de áudio/vídeo (Lip Sync)' }, { sCode: '3180', sDes: 'Metade da imagem escura / anómala' }, { sCode: '3190', sDes: 'Imagem invertida / espelhada' }, { sCode: '31A0', sDes: 'Imagem instável' }, { sCode: '31A1', sDes: 'Sem imagem e sem retroiluminação (Backlight)' }, { sCode: '31A2', sDes: 'Sem imagem mas tem retroiluminação (Backlight)' }, { sCode: '31A4', sDes: 'Ecrã branco' }, { sCode: '31A5', sDes: 'Fuga de luz' }, { sCode: '31A6', sDes: 'Exibição HDR com anomalia' }, { sCode: '31A7', sDes: 'Imagem desfocada' }, { sCode: '31A8', sDes: 'Atraso de entrada / Input Lag' }, { sCode: '31A9', sDes: 'Interferência estriada / ondulada na imagem' }, { sCode: '321', sDes: 'Imagem demasiado escura' }, { sCode: '34C', sDes: 'Efeito Clouding / "MURA"' }, { sCode: '355', sDes: 'Imagem a piscar / Flicker' }, { sCode: '385', sDes: 'Píxeis brilhantes, escuros ou intermitentes' }, { sCode: '38G', sDes: 'Linhas ou faixas verticais' }, { sCode: '38H', sDes: 'Linhas ou faixas horizontais' }, { sCode: '420', sDes: 'Problema no nível de cor' }] },
        { fCode: 'A510', fDes: 'Problema de áudio / ruído', subCodes: [{ sCode: '140', sDes: 'Ruído anómalo' }, { sCode: '317', sDes: 'Problema de linha vertical / barra' }, { sCode: '510', sDes: 'Sem áudio' }, { sCode: '5120', sDes: 'Som do dispositivo externo anómalo' }, { sCode: '5130', sDes: 'Som da barra de som anómalo' }, { sCode: '517', sDes: 'Sem som nos auscultadores' }, { sCode: '519', sDes: 'Sem som na saída digital' }, { sCode: '51A1', sDes: 'Ligação ARC sem som' }, { sCode: '51A2', sDes: 'Sem saída de som em AV/VGA/HDMI' }, { sCode: '51X', sDes: 'Outro problema de som' }, { sCode: '521', sDes: 'Volume de áudio baixo' }, { sCode: '522', sDes: 'Volume de áudio elevado' }, { sCode: '5230', sDes: 'Som fora de controlo' }, { sCode: '54B', sDes: 'Som imperfeito / distorcido' }, { sCode: '553', sDes: 'Cortes intermitentes no áudio' }, { sCode: '645', sDes: 'Ruído anómalo na ventoinha' }] },
        { fCode: 'A740', fDes: 'Teclado / Botão tátil', subCodes: [{ sCode: '163', sDes: 'Problema nos botões' }, { sCode: '741', sDes: 'Botão / botão tátil não funciona' }, { sCode: '744', sDes: 'Tecla presa / dura de pressionar' }, { sCode: '74A1', sDes: 'Modelo de comando não corresponde a esta TV' }, { sCode: '74A2', sDes: 'Botão/tecla pouco sensível' }] },
        { fCode: 'A810', fDes: 'Problema com acessório / base', subCodes: [{ sCode: '81A1', sDes: 'Sem acessórios' }, { sCode: '81A2', sDes: 'Sem comando' }, { sCode: '81A3', sDes: 'Sem cartão CI / cartão B-CAS' }, { sCode: '81A4', sDes: 'Sem suporte de base' }, { sCode: '81A5', sDes: 'Sem parafusos / parafusos incorretos' }, { sCode: '81A6', sDes: 'Sem suporte / suporte incorreto' }, { sCode: '81A7', sDes: 'Comando incorreto' }, { sCode: '81A8', sDes: 'Acessório incorreto' }, { sCode: '81A9', sDes: 'Acessório danificado' }, { sCode: '81B1', sDes: 'Base danificada' }, { sCode: '81B2', sDes: 'Sem manual' }, { sCode: '81B3', sDes: 'Outro problema de acessórios' }, { sCode: '81B4', sDes: 'Base instável' }, { sCode: '81B5', sDes: 'Rosca espanada na base' }, { sCode: '81B6', sDes: 'Falta de proteção de borracha na base' }, { sCode: 'Z0A3', sDes: 'Não é possível instalar o suporte de parede' }, { sCode: 'Z0A4', sDes: 'Não é possível instalar a base' }, { sCode: 'Z0A5', sDes: 'Base não desmonta' }] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [{ sCode: 'Y4', sDes: 'Instalação do produto' }] },
        { fCode: 'Z00', fDes: 'Outros problemas', subCodes: [{ sCode: '319', sDes: 'Sem imagem no 2º monitor (ou superior)' }, { sCode: 'PC', sDes: 'Recolha de Produto Defeituoso' }, { sCode: 'Z01', sDes: 'Questão de instalação/requisito do utilizador' }, { sCode: 'Z02', sDes: 'Depuração / Teste / Verificação' }, { sCode: 'Z03', sDes: 'Requer configuração no arranque' }, { sCode: 'Z04', sDes: 'Produto errado na embalagem' }, { sCode: 'Z05', sDes: 'Danificado pelo cliente' }, { sCode: 'Z06', sDes: 'Lesão do consumidor' }, { sCode: 'Z07', sDes: 'Danos materiais' }] },
    ],
    WC1: [
        { fCode: '11', fDes: 'NÃO ARREFECE', subCodes: [] },
        { fCode: '12', fDes: 'NÃO ARREFECE O SUFICIENTE', subCodes: [] },
        { fCode: '13', fDes: 'FUGA DE ÁGUA', subCodes: [] },
        { fCode: '14', fDes: 'ACUMULAÇÃO DE GELO', subCodes: [] },
        { fCode: '21', fDes: 'COMPRESSOR NÃO ARRANCA', subCodes: [] },
        { fCode: '22', fDes: 'ZONA DE GELO E ZONA DE REFRIGERAÇÃO NÃO FUNCIONAM', subCodes: [] },
        { fCode: '23', fDes: 'FALHA NOS COMPONENTES ELÉTRICOS', subCodes: [] },
        { fCode: '24', fDes: 'Componente em falta, enviar para o cliente', subCodes: [] },
        { fCode: '25', fDes: 'Problema na função de ecrã / visualização', subCodes: [] },
        { fCode: '27', fDes: 'Não desliga completamente', subCodes: [] },
        { fCode: '28', fDes: 'Sem alimentação / Não liga', subCodes: [] },
        { fCode: '29', fDes: 'Menus no ecrã (On Screen Display)', subCodes: [] },
        { fCode: '31', fDes: 'MONTAGEM DEFEITUOSA', subCodes: [] },
        { fCode: '32', fDes: 'DEMASIADO RUIDOSO', subCodes: [] },
        { fCode: '33', fDes: 'PROBLEMA DE APARÊNCIA', subCodes: [] },
        { fCode: '40', fDes: 'Outro', subCodes: [] },
        { fCode: '55', fDes: 'Ruído de trituração / fricção', subCodes: [] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [] },
    ],
    WM1: [
        { fCode: '110', fDes: 'Problema de alimentação ou não funciona', subCodes: [{ sCode: '111', sDes: 'Sem alimentação / Não liga' }, { sCode: '11A', sDes: 'Dá sinal/Liga mas não funciona' }, { sCode: '11C', sDes: 'Dispara fusível externo (rede)' }, { sCode: '11F', sDes: 'Não funciona' }] },
        { fCode: '130', fDes: 'Problema na função de visualização / ecrã', subCodes: [{ sCode: '13D', sDes: 'Luz de aviso não funciona' }] },
        { fCode: '140', fDes: 'Ruído anómalo', subCodes: [{ sCode: '146', sDes: 'Matraquear / vibração' }, { sCode: '14F', sDes: 'Chiar / Ruído agudo' }] },
        { fCode: '160', fDes: 'Danos físicos', subCodes: [{ sCode: '161', sDes: 'Chassis / painel danificado ou deformado' }, { sCode: '163', sDes: 'Manípulo(s) de controlo / botão(ões) danificado(s)' }, { sCode: '164', sDes: 'Porta / tampa danificada' }, { sCode: '165', sDes: 'Vedante / junta danificada' }, { sCode: '16E', sDes: 'Danos na superfície externa' }, { sCode: '16P', sDes: 'Acessório danificado' }, { sCode: '16R', sDes: 'Descoloração' }, { sCode: '16U', sDes: 'Embalagem' }, { sCode: '16Y', sDes: 'Deformação/fratura de peças estéticas' }] },
        { fCode: '170', fDes: 'Problema de funcionamento geral', subCodes: [{ sCode: '171', sDes: 'Função de relógio com falha' }, { sCode: '174', sDes: 'Funcionamento do temporizador com falha' }, { sCode: '17E', sDes: 'Código de erro / sinal aparece no ecrã' }, { sCode: '17M', sDes: 'Falha na comutação de modo' }, { sCode: '17P', sDes: 'Falha na função de controlo do utilizador' }, { sCode: '17X', sDes: 'Outro problema de funcionamento geral' }, { sCode: '17Y', sDes: 'Alarme durante o funcionamento' }] },
        { fCode: '180', fDes: 'Requisitos especiais', subCodes: [{ sCode: '186', sDes: 'Produto errado na caixa' }, { sCode: '187', sDes: 'Acessório errado ou em falta' }] },
        { fCode: '190', fDes: 'Odor / Cheiro', subCodes: [{ sCode: '191', sDes: 'Cheiro a queimado' }, { sCode: '193', sDes: 'Cheiro a borracha' }, { sCode: '194', sDes: 'Cheiro a podre / águas residuais' }, { sCode: '195', sDes: 'Cheiro a plástico' }, { sCode: '19X', sDes: 'Outro problema específico de odor' }] },
        { fCode: '230', fDes: 'Problema de transmissão / ligação', subCodes: [{ sCode: '231', sDes: 'Sem transmissão / ligação' }] },
        { fCode: '650', fDes: 'Instabilidade mecânica', subCodes: [{ sCode: '653', sDes: 'A vibrar / a saltar' }, { sCode: '659', sDes: 'Incapaz de travar ou travagem demasiado longa' }] },
        { fCode: '690', fDes: 'Porta / tampa danificada', subCodes: [{ sCode: '693', sDes: 'Porta não fecha corretamente' }, { sCode: '694', sDes: 'Porta não abre / muito pesada para abrir' }, { sCode: '698', sDes: 'Porta cai' }, { sCode: '69B', sDes: 'Dobradiça danificada' }] },
        { fCode: 'A10', fDes: 'Não funciona / Sem função', subCodes: [{ sCode: 'A11', sDes: 'Não aquece' }, { sCode: 'A12', sDes: 'Não escoa / não bombeia a água para fora' }, { sCode: 'A14', sDes: 'Não seca' }, { sCode: 'A17', sDes: 'Não consome detergente' }, { sCode: 'A18', sDes: 'Não entra água' }, { sCode: 'A1B', sDes: 'Não centrifugas' }, { sCode: 'A1C', sDes: 'Para durante o ciclo do programa' }, { sCode: 'A1G', sDes: 'Entrada de água não para' }] },
        { fCode: 'A20', fDes: 'Problema operacional', subCodes: [{ sCode: 'A21', sDes: 'Escoamento de água incorreto' }, { sCode: 'A22', sDes: 'Entrada de água insuficiente' }, { sCode: 'A23', sDes: 'Secagem / centrifugação insuficiente' }, { sCode: 'A28', sDes: 'Ciclo do programa demasiado rápido / lento' }, { sCode: 'A2A', sDes: 'Centrifugação incorreta' }, { sCode: 'A2E', sDes: 'Água entra e sai imediatamente por escoamento' }, { sCode: 'A2G', sDes: 'Tempo de secagem demasiado longo' }] },
        { fCode: 'A30', fDes: 'Desempenho deficiente de lavagem / limpeza', subCodes: [{ sCode: 'A31', sDes: 'Não lava bem / fica sujo' }, { sCode: 'A3D', sDes: 'Roupa danificada' }] },
        { fCode: 'A40', fDes: 'Ruído', subCodes: [{ sCode: 'A44', sDes: 'Ruído na centrifugação' }, { sCode: 'A4X', sDes: 'Outro problema de ruído' }] },
        { fCode: 'A50', fDes: 'Fuga e danos na entrada / saída', subCodes: [{ sCode: 'A51', sDes: 'Fuga de água' }] },
        { fCode: 'PC', fDes: 'Recolha de Produto Defeituoso', subCodes: [{ sCode: 'PC', sDes: 'Recolha de Produto Defeituoso' }] },
        { fCode: 'Y4', fDes: 'Instalação do produto', subCodes: [{ sCode: 'Y4', sDes: 'Instalação do produto' }] },
    ],
};

export const defectCodes = {
    AC1: [
        { code: '16D', des: 'Equipamento a queimar / emite fumo' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '7', des: 'Ligação incorreta da linha de extensão' },
        { code: '702', des: 'Cabo de ligação conectado incorretamente' },
        { code: '74', des: 'Válvula de quatro vias não inverte' },
        { code: '8A', des: 'Instalação danificada' },
        { code: '8B', des: 'Fuga na instalação' },
        { code: '9', des: 'Utilização incorreta pelo cliente' },
        { code: 'AD3F', des: 'Inclinado / Inclinação' },
        { code: 'ADB3', des: 'Obstrução / Bloqueio' },
        { code: 'ADC2', des: 'Desgaste por atrito' },
        { code: 'ADE3', des: 'Deslocalização / Desalinhamento' },
        { code: 'ADE5', des: 'Não recebe / Sem receção' },
        { code: 'ADEB', des: 'Problema de comunicação' },
        { code: 'B1', des: 'Filtro sujo' },
        { code: 'CS', des: 'Condensador inchado / deformado' },
        { code: 'D12', des: 'Ecrã do comando por cabo partido' },
        { code: 'D13', des: 'Ecrã do comando à distância partido' },
        { code: 'D14', des: 'Pás do ventilador com fissuras/partidas' },
        { code: 'D15', des: 'Fratura no tubo de cobre' },
        { code: 'D16', des: 'Rotura no tubo de cobre' },
        { code: 'D17', des: 'Rutura do IGBT' },
        { code: 'D18', des: 'Rutura do IPM' },
        { code: 'D19', des: 'Rutura do NTC' },
        { code: 'D1A', des: 'Cabo danificado' },
        { code: 'D1B', des: 'Chip avariado / partido' },
        { code: 'D1C', des: 'Interruptor de emergência partido' },
        { code: 'D1D', des: 'Peça do suporte da base partida' },
        { code: 'D1E', des: 'Motor incapaz de funcionar' },
        { code: 'D1F', des: 'Problema no motor da bomba de água' },
        { code: 'D1G', des: 'Problema no enrolamento secundário do motor' },
        { code: 'D1H', des: 'Problema no enrolamento principal do motor' },
        { code: 'D1J', des: 'Eixo do motor DC roda com muita rigidez' },
        { code: 'D1K', des: 'Resistência do motor DC anómala' },
        { code: 'D1L', des: 'Eixo do motor não consegue rodar' },
        { code: 'D1M', des: 'Velocidade do motor anómala' },
        { code: 'D1N', des: 'Bateria / Pilha fraca' },
        { code: 'D1O', des: 'Falha no tubo transmissor' },
        { code: 'D1P', des: 'Objeto estranho no interior do ecrã' },
        { code: 'D20', des: 'Luz LED fundida / partida' },
        { code: 'DAMP', des: 'Placa eletrónica (PCB) húmida' },
        { code: 'E', des: 'Deformado' },
        { code: 'F', des: 'Encaixe partido / dano' },
        { code: 'GA17', des: 'Visualização incompleta no ecrã' },
        { code: 'GAA0', des: 'Falha de instalação' },
        { code: 'GAA3', des: 'Falha de instalação por falta de refrigerante' },
        { code: 'GAA4', des: 'Falha de instalação (núcleo da válvula globo solto)' },
        { code: 'GAA5', des: 'Unidade exterior com falta de refrigerante' },
        { code: 'GAA6', des: 'Falha de instalação (tubo de extensão int/ext)' },
        { code: 'GAA7', des: 'Falha de instalação (tampa de latão exterior solta)' },
        { code: 'GB28', des: 'Sem visualização / ecrã apagado' },
        { code: 'GB31', des: 'Falta de acessório' },
        { code: 'GC17', des: 'Imagem desfocada / enevoada' },
        { code: 'GE01', des: 'Preso / Bloqueado' },
        { code: 'GF20', des: 'Problema tátil (Touch)' },
        { code: 'GF28', des: 'Falha nos botões' },
        { code: 'GG28', des: 'Ecrã escuro' },
        { code: 'GH28', des: 'Alto consumo de energia' },
        { code: 'H1', des: 'Fissurado / descascado' },
        { code: 'H2', des: 'Corroído' },
        { code: 'H21', des: 'Placa eletrónica (PCB) corroída' },
        { code: 'H5', des: 'Fusível fundido' },
        { code: 'H6', des: 'Condensação na unidade' },
        { code: 'I', des: 'Solto / espanado' },
        { code: 'I1', des: 'Terminal solto / espanado' },
        { code: 'I2', des: 'Sonda de temperatura solta / espanada' },
        { code: 'I3', des: 'Parafusos soltos / em falta' },
        { code: 'I4', des: 'Desgaste localizado / lascado' },
        { code: 'J2', des: 'A vibrar' },
        { code: 'J3', des: 'Ruidoso' },
        { code: 'J4', des: 'Problema de comunicação' },
        { code: 'J5', des: 'Aleta irregular' },
        { code: 'J6', des: 'Colisão de peças internas da unidade' },
        { code: 'K', des: 'Fuga' },
        { code: 'K4', des: 'Fuga em componentes' },
        { code: 'K5', des: 'Fuga na soldadura' },
        { code: 'K6', des: 'Fuga na curva do tubo' },
        { code: 'L1', des: 'Falta de gás refrigerante' },
        { code: 'L4', des: 'Rolamentos sem lubrificação' },
        { code: 'M', des: 'Corpo estranho' },
        { code: 'M03', des: 'Insetos no interior da placa (PCB)' },
        { code: 'M1', des: 'Bloqueado / Obstruído' },
        { code: 'M2', des: 'Tubo de cobre obstruído por soldadura' },
        { code: 'M3', des: 'Bloqueio por corpos estranhos' },
        { code: 'N', des: 'Componente elétrico / módulo com defeito' },
        { code: 'NB1', des: 'Aviso sonoro (Buzzer) a apitar' },
        { code: 'O', des: 'Queimado, arco elétrico' },
        { code: 'O7', des: 'Defeitos de píxeis fora da especificação no ecrã' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'Q', des: 'Circuito aberto, Curto-circuito' },
        { code: 'S', des: 'Fuga elétrica / passagem' },
        { code: 'T2', des: 'Contacto de tubos' },
        { code: 'TH', des: 'Soldadura de pinos do tubo digital' },
        { code: 'U', des: 'Esclarecido presencialmente com o cliente' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Z', des: 'Falta / Ausência' },
        { code: 'Z1', des: 'Falta de esferas no rolamento' },
        { code: 'Z3', des: 'Casquilhos em falta' },
    ],
    BAR: [
        { code: '1', des: 'Problema de software (NÃO causado pelo utilizador)' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '51', des: 'Tensão de rede elétrica com falha' },
        { code: '6', des: 'Incapaz de diagnosticar a avaria' },
        { code: '7', des: 'Incorretamente cablado / montado' },
        { code: '72', des: 'Tentativa de reparação anterior incompleta ou incorreta' },
        { code: '73', des: 'Dano / defeito causado durante o processo de reparação' },
        { code: '8', des: 'Falha de instalação' },
        { code: '81', des: 'Ligação incorreta do equipamento' },
        { code: '9', des: 'Utilização incorreta pelo cliente' },
        { code: 'A1', des: 'Mau funcionamento' },
        { code: 'B', des: 'Sujo / obstruído' },
        { code: 'DOA', des: 'DOA (Defeituoso de fábrica / Fora da caixa)' },
        { code: 'E', des: 'Deformado' },
        { code: 'F', des: 'Partido / quebrado' },
        { code: 'G', des: 'Riscado / amolgado / arestas vivas' },
        { code: 'H', des: 'Fissurado / descascado / corroído / derretido' },
        { code: 'I', des: 'Solto / desprendido / espanado' },
        { code: 'M', des: 'Corpo estranho' },
        { code: 'N', des: 'Componente elétrico / módulo com defeito' },
        { code: 'Q', des: 'Curto-circuito' },
        { code: 'R', des: 'Circuito aberto' },
        { code: 'T', des: 'Mau contacto / ligação deficiente' },
        { code: 'V', des: 'Placa de circuito impresso com fissura' },
        { code: 'Y', des: 'Componente / módulo / acessório errado' },
        { code: 'Z', des: 'Componente / módulo / acessório em falta' },
    ],
    CD1: [
        { code: '2', des: 'Problema no módulo Wi-Fi' },
        { code: '4', des: 'Problema na placa T-CON' },
        { code: '5', des: 'Problema na placa de botões/controlo remoto' },
        { code: '51', des: 'Tensão de rede elétrica com falha' },
        { code: '8', des: 'Problema na placa de botões (Key Board)' },
        { code: 'A', des: 'Problema nos altifalantes' },
        { code: 'B', des: 'Problema nos botões' },
        { code: 'D', des: 'Problema na tampa frontal/traseira' },
        { code: 'D1', des: 'Problema na placa principal e placa de potência' },
        { code: 'D2', des: 'Problema na placa principal (Main Board)' },
        { code: 'D3', des: 'Problema na placa Inverter' },
        { code: 'D5', des: 'Problema no controlo remoto' },
        { code: 'D6', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: 'D7', des: 'Problema na placa de retroiluminação (Backlight)' },
        { code: 'D8', des: 'Problema nas réguas de LEDs' },
        { code: 'E', des: 'Deformado' },
        { code: 'G', des: 'Problema de Software' },
        { code: 'H', des: 'Problema de embalagem' },
        { code: 'HTD1', des: 'Projeção sem fios (Cast) não ativada' },
        { code: 'HTD2', des: 'Falha na projeção sem fios (Cast)' },
        { code: 'I', des: 'Problema na base' },
        { code: 'I1', des: 'Não soldado ou colado / rutura de soldadura' },
        { code: 'J', des: 'Problema na placa de alimentação (Power Board)' },
        { code: 'J1', des: 'Problema no transformador AC' },
        { code: 'J2', des: 'Problema no cabo de alimentação' },
        { code: 'K', des: 'DOA (Defeituoso de fábrica / Fora da caixa)' },
        { code: 'LD01', des: 'Lâmpada danificada' },
        { code: 'LD02', des: 'Dano extenso no módulo' },
        { code: 'LD03', des: 'Tensão da placa recetora anómala' },
        { code: 'LD04', des: 'Falha na placa recetora' },
        { code: 'LD05', des: 'Componentes PDC danificados' },
        { code: 'LD06', des: 'Chip de controlo/Driver com defeito' },
        { code: 'LD07', des: 'Curto-circuito' },
        { code: 'M', des: 'Problema no cabo de ligação' },
        { code: 'O', des: 'Problema no painel' },
        { code: 'P', des: 'Problema por danos físicos' },
        { code: 'Q', des: 'Problema no cabo FFC/LVDS' },
        { code: 'S', des: 'Problema de configuração do utilizador' },
        { code: 'SXD1', des: 'Corpo estranho na superfície do vidro/filtro' },
        { code: 'SXD2', des: 'Interferência por outro dispositivo tátil' },
        { code: 'SXD3', des: 'Ecrã bloqueado' },
        { code: 'SXD4', des: 'Problema de instalação da placa tátil' },
        { code: 'SXD5', des: 'Falha na placa adaptadora OPS' },
        { code: 'SXD6', des: 'Falha no OPS' },
        { code: 'SXD7', des: 'Falha na moldura tátil' },
        { code: 'SXD8', des: 'Dano no terminal USB' },
        { code: 'SXD9', des: 'Dano no terminal' },
        { code: 'T', des: 'Problema de transporte / logística' },
        { code: 'T1', des: 'Corpo estranho no interior' },
        { code: 'T2', des: 'Suporte difusor' },
        { code: 'T3', des: 'Problema na barra de som' },
        { code: 'T4', des: 'Cabo [Rc:Mn-Key/Em/Rc]' },
        { code: 'T5', des: 'Compatibilidade do dispositivo' },
        { code: 'T6', des: 'Cabo [Ub:Main-Wifi]' },
        { code: 'T7', des: 'Problema no sinal de entrada' },
        { code: 'T8', des: 'Problema na ventoinha' },
        { code: 'T9', des: 'Problema no circuito de comando da ventoinha' },
        { code: 'TA', des: 'Problema em dispositivo externo' },
        { code: 'TB', des: 'Compatibilidade com dispositivo externo' },
        { code: 'TC', des: 'Problema de Internet' },
        { code: 'TD', des: 'Falha na atualização OTA' },
        { code: 'TE', des: 'Problema no disco rígido (HDD)' },
        { code: 'TF', des: 'Problema no botão interruptor' },
        { code: 'TG', des: 'Problema no módulo de voz' },
        { code: 'W', des: 'Problema por utilização incorreta do cliente' },
        { code: 'Y4', des: 'Instalação do produto' },
    ],
    DH1: [
        { code: 'AD00', des: 'Peças ou acessórios em falta' },
        { code: 'ADA1', des: 'Obstrução na válvula de quatro vias' },
        { code: 'ADA2', des: 'Bobine da válvula de quatro vias queimada' },
        { code: 'ADA3', des: 'Ruído na válvula de quatro vias' },
        { code: 'ADB1', des: 'Obstrução ruidosa na válvula de expansão' },
        { code: 'ADB2', des: 'Bobine da válvula de expansão ruidosa queimada' },
        { code: 'ADB3', des: 'Bloqueio no motor do ventilador' },
        { code: 'ADC1', des: 'Bobine do motor do ventilador queimada' },
        { code: 'ADC2', des: 'Ruído proveniente do motor do ventilador' },
        { code: 'ADC3', des: 'Termóstato com mau contacto' },
        { code: 'ADD1', des: 'Termóstato com controlo de temperatura deficiente' },
        { code: 'ADD2', des: 'Fuga elétrica no termóstato' },
        { code: 'ADD3', des: 'Corrente de funcionamento do compressor demasiado alta' },
        { code: 'ADD4', des: 'Compressor sem ação / não arranca' },
        { code: 'ADD5', des: 'Baixa pressão no tubo de aspiração do compressor' },
        { code: 'ADE1', des: 'Fuga elétrica no compressor' },
        { code: 'ADE2', des: 'Bobine do compressor queimada' },
        { code: 'ADE3', des: 'Falha na placa de exibição / display' },
        { code: 'ADE4', des: 'Falha na placa de controlo' },
        { code: 'ADE5', des: 'Falha na placa do filtro' },
        { code: 'ADE6', des: 'Falha na placa IPM' },
        { code: 'ADE7', des: 'Fusível elétrico fundido' },
        { code: 'ADE8', des: 'Falha de capacidade no motor do ventilador' },
        { code: 'ADE9', des: 'Falha de capacidade no compressor' },
        { code: 'ADEA', des: 'Falha no sensor de temperatura' },
        { code: 'ADEB', des: 'Falha de comunicação entre unidade interior e exterior' },
        { code: 'ADEC', des: 'Problema na linha de alimentação' },
        { code: 'ADED', des: 'Motor do ventilador interior ruidoso' },
        { code: 'ADEE', des: 'Motor do ventilador exterior ruidoso' },
        { code: 'ADEF', des: 'Compressor ruidoso' },
        { code: 'ADEG', des: 'Sistema de refrigeração ruidoso' },
        { code: 'ADEH', des: 'Outros componentes ruidosos' },
        { code: 'ADEI', des: 'Desnivelamento / colocação instável no interior' },
        { code: 'ADEJ', des: 'Problema de instalação no exterior' },
        { code: 'ADEK', des: 'Obstrução no tubo de escoamento / drenagem' },
        { code: 'ADEL', des: 'Condensação no painel interior' },
        { code: 'ADEM', des: 'Ventilador a expelir água' },
        { code: 'ADEN', des: 'Tabuleiro de água danificado' },
        { code: 'ADEO', des: 'Fuga de gás no condensador' },
        { code: 'ADEP', des: 'Fuga de gás na VÁLVULA DE 2 VIAS' },
        { code: 'ADEQ', des: 'Fuga de gás na VÁLVULA DE 3 VIAS' },
        { code: 'ADER', des: 'Fuga de gás na VÁLVULA DE 4 VIAS' },
        { code: 'AD01', des: 'Fuga de água no interior' },
        { code: 'ADES', des: 'Fuga de gás no evaporador' },
        { code: 'ADET', des: 'Fuga de gás noutros tubos de refrigeração' },
        { code: 'ADEU', des: 'Fuga de gás detetada mas ponto de fuga não localizado' },
        { code: 'ADEV', des: 'Obstrução no sistema de refrigeração' },
        { code: 'ADEW', des: 'Unidade exterior enferrujada' },
        { code: 'ADEX', des: 'Chassis danificado ou deformado' },
        { code: 'ADEY', des: 'Fissura no motor do ventilador interior' },
        { code: 'ADEZ', des: 'Fissura no motor do ventilador exterior' },
        { code: 'NR', des: 'Reparação economicamente inviável' },
    ],
    DW1: [
        { code: 'A001', des: 'Cabo de alimentação com ficha' },
        { code: 'A002', des: 'Resistência de aquecimento' },
        { code: 'A003', des: 'Luz piloto / indicador' },
        { code: 'A004', des: 'Lâmpada / lâmpada incandescente' },
        { code: 'A005', des: 'Cablagem / chicote de cabos' },
        { code: 'A006', des: 'Bloco de terminais / régua de bornes' },
        { code: 'A007', des: 'Sensor de temperatura / NTC / PTC' },
        { code: 'A008', des: 'Termóstato / Termorregulador' },
        { code: 'A009', des: 'Condensador' },
        { code: 'A011', des: 'Filtro RFI / EMC' },
        { code: 'A013', des: 'Eletroválvula' },
        { code: 'A014', des: 'Fecho da porta' },
        { code: 'A016', des: 'Sensor de turbidez' },
        { code: 'A017', des: 'Sensor de nível de água' },
        { code: 'A019', des: 'Sonda do termóstato' },
        { code: 'A022', des: 'Ventoinha / ventilador' },
        { code: 'A029', des: 'Fusível térmico' },
        { code: 'A032', des: 'Resistência de aquecimento inferior' },
        { code: 'A033', des: 'Resistência de aquecimento traseira / ar quente' },
        { code: 'A034', des: 'Resistência de aquecimento superior' },
        { code: 'A035', des: 'Indicador de calor residual' },
        { code: 'A036', des: 'Pino de conector / tomada' },
        { code: 'A038', des: 'Fusível' },
        { code: 'A039', des: 'Sonda térmica para carne / sensor' },
        { code: 'A041', des: 'Interruptor bipolar' },
        { code: 'A042', des: 'Comutador de 7 posições / energia – simples' },
        { code: 'A043', des: 'Comutador de energia triplo' },
        { code: 'A044', des: 'Comutador de energia para dupla resistência' },
        { code: 'A047', des: 'Lâmpada de iluminação do manípulo' },
        { code: 'A051', des: 'Transformador' },
        { code: 'A052', des: 'Cabo LIN' },
        { code: 'A053', des: 'Faixa de luz do painel de controlo' },
        { code: 'A060', des: 'Elemento de aquecimento cerâmico' },
        { code: 'A061', des: 'Placa de cozedura em ferro fundido' },
        { code: 'A072', des: 'Fluxómetro / medidor de volume de água' },
        { code: 'A073', des: 'Microinterruptor' },
        { code: 'A074', des: 'Contacto magnético / sensor reed' },
        { code: 'A076', des: 'Termóstato de segurança / TCO' },
        { code: 'A081', des: 'Suporte do interruptor da porta (completo)' },
        { code: 'A084', des: 'Díodo de alta tensão' },
        { code: 'A100', des: 'Tubo de micro-ondas' },
        { code: 'A101', des: 'Interruptor de energia' },
        { code: 'A103', des: 'Magnetrão' },
        { code: 'A108', des: 'Atuador' },
        { code: 'A125', des: 'Potenciómetro' },
        { code: 'A143', des: 'Sensor de sal' },
        { code: 'A149', des: 'Sensor de abrilhantador' },
        { code: 'A151', des: 'Conjunto hidráulico do motor' },
        { code: 'A158', des: 'Gerador de vapor' },
        { code: 'A183', des: 'Interruptor de atraso' },
        { code: 'A187', des: 'Válvula de comutação / Distribuidor' },
        { code: 'A199', des: 'Gerador de indução' },
        { code: 'A202', des: 'Motor do prato rotativo' },
        { code: 'A203', des: 'Fusível de alta tensão (HV)' },
        { code: 'A204', des: 'Inverter' },
        { code: 'A208', des: 'Módulo Wi-Fi' },
        { code: 'A209', des: 'Aplicação móvel (App)' },
        { code: 'B003', des: 'Mangueira de ligação interna' },
        { code: 'C001', des: 'Unidade de controlo (placa lógica, potência)' },
        { code: 'C002', des: 'Ecrã / teclado / tátil' },
        { code: 'C003', des: 'Painel de controlo' },
        { code: 'C004', des: 'Manípulo seletor (temperatura, centrifugação)' },
        { code: 'C006', des: 'Interruptor (chave)' },
        { code: 'C010', des: 'Manípulo retrátil (Push-Pull)' },
        { code: 'C011', des: 'Junta do manípulo' },
        { code: 'C012', des: 'Regulação do motor / inverter' },
        { code: 'C015', des: 'Temporizador / conta-minutos' },
        { code: 'D001', des: 'Parte interna da porta' },
        { code: 'D002', des: 'Parte externa da porta' },
        { code: 'D003', des: 'Dobradiça da porta' },
        { code: 'D012', des: 'Junta magnética - vedante da porta' },
        { code: 'D020', des: 'Tranque da porta / bloqueio infantil' },
        { code: 'D023', des: 'Mecanismo de abertura da porta' },
        { code: 'D025', des: 'Porta completa' },
        { code: 'D027', des: 'Vidro intermédio' },
        { code: 'D029', des: 'Conduta de ar da porta' },
        { code: 'D032', des: 'Película protetora / vidro protetor' },
        { code: 'G001', des: 'Parafuso de ajuste do mínimo (gás)' },
        { code: 'G002', des: 'Grelha de suporte / cruzeta do queimador' },
        { code: 'G003', des: 'Tampa do queimador' },
        { code: 'G004', des: 'Espalhador do queimador' },
        { code: 'G005', des: 'Queimador do forno' },
        { code: 'G006', des: 'Queimador do forno – infravermelhos' },
        { code: 'G007', des: 'Tubo do queimador de cozedura' },
        { code: 'G008', des: 'Tubo do queimador do forno / infravermelhos' },
        { code: 'G009', des: 'Suporte do injetor – forno / infravermelhos' },
        { code: 'G010', des: 'Injetor / bico' },
        { code: 'G011', des: 'Torneira de gás – queimador de cozedura' },
        { code: 'G012', des: 'Torneira de gás – controlada por termóstato' },
        { code: 'G013', des: 'Vedante do eixo da torneira de gás' },
        { code: 'G014', des: 'Inserção eletromagnética' },
        { code: 'G015', des: 'Ligação de gás' },
        { code: 'G016', des: 'Vela de ignição / cabo – queimador de cozedura' },
        { code: 'G017', des: 'Vela de ignição – queimador infravermelhos' },
        { code: 'G018', des: 'Termopar – queimador de cozedura' },
        { code: 'G019', des: 'Termopar – queimador do forno' },
        { code: 'G020', des: 'Termopar – queimador infravermelhos' },
        { code: 'G021', des: 'Interruptor do dispositivo de ignição' },
        { code: 'G022', des: 'Dispositivo de ignição' },
        { code: 'G023', des: 'Junta do queimador' },
        { code: 'G024', des: 'Mola do queimador' },
        { code: 'G025', des: 'Pé de suporte da grelha' },
        { code: 'G026', des: 'Freio/freio ómega do veio da torneira de gás' },
        { code: 'G027', des: 'Kit de injetores' },
        { code: 'G028', des: 'Tubo de gás' },
        { code: 'G029', des: 'Joelheiro de ligação / peça angular' },
        { code: 'G030', des: 'Tubagem' },
        { code: 'G031', des: 'Corpo do queimador / suporte do injetor da placa' },
        { code: 'G032', des: 'Queimador' },
        { code: 'G034', des: 'Sonda de ionização' },
        { code: 'G038', des: 'ESPAÇADOR DE SUPORTE DE GRELHA' },
        { code: 'H001', des: 'Corpo do chassis / carcaça' },
        { code: 'H002', des: 'Bancada de trabalho / tampo' },
        { code: 'H004', des: 'Mola' },
        { code: 'H005', des: 'Pés ajustáveis / rodas / perna de nivelamento' },
        { code: 'H008', des: 'Rodapé / plinto / grelha de ventilação' },
        { code: 'H016', des: 'Guia de calha' },
        { code: 'H017', des: 'Chassis diverso' },
        { code: 'H019', des: 'Placa de cozinha' },
        { code: 'H020', des: 'Gaveta, base' },
        { code: 'H022', des: 'Parede protetora, parede traseira' },
        { code: 'H023', des: 'Corpo da dobradiça da porta' },
        { code: 'H024', des: 'Acoplamento cardan' },
        { code: 'H025', des: 'Anel de cobertura / disco' },
        { code: 'H026', des: 'Fixações / elementos de aperto' },
        { code: 'H027', des: 'Componentes de iluminação' },
        { code: 'H028', des: 'Moldura / aro' },
        { code: 'H029', des: 'Fundo / base inferior' },
        { code: 'H034', des: 'Serigrafia' },
        { code: 'H038', des: 'Puxador' },
        { code: 'H045', des: 'Grelha de ventilação (chaminé)' },
        { code: 'H046', des: 'Suporte de encastrar' },
        { code: 'H047', des: 'Friso decorativo' },
        { code: 'H048', des: 'Borracha da placa inferior' },
        { code: 'H050', des: 'Filtro de gordura sintético / metálico' },
        { code: 'H054', des: 'Chassis do motor do ventilador' },
        { code: 'H055', des: 'Pá do ventilador' },
        { code: 'H067', des: 'Mangueira' },
        { code: 'H077', des: 'CONSOLA' },
        { code: 'H086', des: 'Puxador do cesto da fritadeira' },
        { code: 'H106', des: 'Isolamento acústico' },
        { code: 'H108', des: 'Isolamento térmico' },
        { code: 'H120', des: 'Alavanca' },
        { code: 'H123', des: 'Direcionador de micro-ondas' },
        { code: 'H126', des: 'Drenagem de vapor/condensação no teto' },
        { code: 'H127', des: 'Drenagem de vapor/condensação na porta' },
        { code: 'H128', des: 'Placa de mica' },
        { code: 'H139', des: 'Hidrociclone' },
        { code: 'H141', des: 'Kit de instalação' },
        { code: 'H142', des: 'Suporte do ventilador' },
        { code: 'L001', des: 'Correia de transmissão' },
        { code: 'L003', des: 'Prato rotativo' },
        { code: 'L004', des: 'Prato de vidro' },
        { code: 'L005', des: 'Aro de suporte do prato rotativo' },
        { code: 'L006', des: 'Eixo/cruzeta de arrastamento do prato' },
        { code: 'M001', des: 'Bomba de entrada / enchimento' },
        { code: 'M002', des: 'Bomba de escoamento / drenagem' },
        { code: 'M003', des: 'Motor elétrico' },
        { code: 'M008', des: 'Motor do espeto rotativo' },
        { code: 'M009', des: 'Motor do ventilador de ar quente / convecção' },
        { code: 'M010', des: 'Motor do ventilador de arrefecimento' },
        { code: 'M013', des: 'Bomba de lavagem / circulação' },
        { code: 'N001', des: 'Cesto inferior' },
        { code: 'N002', des: 'Cesto superior' },
        { code: 'N004', des: 'Roda do cesto' },
        { code: 'N006', des: 'Injetor do chuveiro / aspersor' },
        { code: 'N007', des: 'Braço aspersor inferior' },
        { code: 'N008', des: 'Braço aspersor superior' },
        { code: 'P002', des: 'Suporte do cesto' },
        { code: 'P006', des: 'Filtro de carvão' },
        { code: 'R003', des: 'Filtro' },
        { code: 'R005', des: 'Tampa do depósito de água' },
        { code: 'R008', des: 'Depósito de água' },
        { code: 'T003', des: 'Rolamento de esferas' },
        { code: 'T011', des: 'Contrapeso frontal' },
        { code: 'T024', des: 'Cuba em aço inoxidável' },
        { code: 'V001', des: 'Cavidade do forno / interior do forno' },
        { code: 'V002', des: 'Parede frontal' },
        { code: 'V003', des: 'Junta do forno / vedante' },
        { code: 'V005', des: 'Resguardo / cobertura do motor de convecção' },
        { code: 'V006', des: 'Filtro de gordura' },
        { code: 'V007', des: 'Guia do tabuleiro de cozedura' },
        { code: 'V008', des: 'Tabuleiro de cozedura' },
        { code: 'V009', des: 'Chaminé, tubo de ventilação' },
        { code: 'V010', des: 'Grelha de suporte / grelha auxiliar' },
        { code: 'V011', des: 'Fecho das guias' },
        { code: 'V012', des: 'Grelha' },
        { code: 'V014', des: 'Prato de vidro / prato de cozedura a vapor' },
        { code: 'W001', des: 'Mangueira de entrada de água' },
        { code: 'W002', des: 'Mangueira de escoamento / esgoto' },
        { code: 'W005', des: 'Tubo do pressóstato' },
        { code: 'W011', des: 'Anel de vedação / junta da bomba' },
        { code: 'W012', des: 'Filtro' },
        { code: 'W015', des: 'Distribuidor de detergente / gaveta' },
        { code: 'W018', des: 'Abraçadeira de arame' },
        { code: 'W025', des: 'Interruptor Aquastop / flutuador' },
        { code: 'W038', des: 'Junta da válvula de retenção' },
        { code: 'W040', des: 'Mangueira do sistema "Aqua Stop"' },
        { code: 'W047', des: 'Depósito de sal' },
        { code: 'W049', des: 'Dispositivo Air-break' },
        { code: 'W051', des: 'Reservatório de água' },
        { code: 'W054', des: 'Sifão' },
        { code: 'W055', des: 'Válvula / obturador de água' },
        { code: 'W061', des: 'Junta / vedante' },
        { code: 'W077', des: 'Conduta do braço aspersor superior' },
        { code: 'W078', des: 'Conduta do braço aspersor inferior' },
        { code: 'W086', des: 'Tampa antirretorno / antissobressalto' },
        { code: 'W087', des: 'Cuba de drenagem / cuba plástica' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Z001', des: 'Manual de instalação / manual do utilizador' },
        { code: 'Z002', des: 'Oscilações na tensão de rede elétrica' },
        { code: 'Z003', des: 'Espaço/instalação/temperatura ambiente inadequada' },
        { code: 'Z004', des: 'Pressão de água inadequada' },
        { code: 'Z005', des: 'Sifão entupido' },
        { code: 'Z007', des: 'Pressão de gás inadequada' },
        { code: 'Z012', des: 'Relatório após aprovação' },
    ],
    FF1: [
        { code: '1', des: 'Problema de software (NÃO causado pelo utilizador)' },
        { code: '12', des: 'Configuração ou instalação incorreta do programa' },
        { code: '14', des: 'Problema de configuração do software' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '4', des: 'Nenhum problema encontrado - mal-entendido do cliente' },
        { code: '5', des: 'Nenhum problema encontrado - condições locais' },
        { code: '51', des: 'Tensão de rede elétrica com falha' },
        { code: '6', des: 'Incapaz de diagnosticar a avaria' },
        { code: '7', des: 'Incorretamente cablado / montado' },
        { code: '72', des: 'Tentativa de reparação anterior incorreta' },
        { code: '73', des: 'Dano / defeito causado durante o processo de reparação' },
        { code: '8', des: 'Falha de instalação' },
        { code: '81', des: 'Ligação incorreta do equipamento' },
        { code: '9', des: 'Utilização incorreta pelo cliente' },
        { code: '91', des: 'Sobrecarregado / carregamento incorreto' },
        { code: '92', des: 'Manutenção deficiente' },
        { code: 'B', des: 'Sujo / obstruído' },
        { code: 'D', des: 'Cortado / partido' },
        { code: 'E', des: 'Deformado' },
        { code: 'F', des: 'Partido / quebrado' },
        { code: 'F1', des: 'Encravado / preso' },
        { code: 'F3', des: 'Congelado / com gelo' },
        { code: 'F4', des: 'Dobrado / vincado / esmagado' },
        { code: 'G', des: 'Riscado / amolgado / arestas vivas' },
        { code: 'G2', des: 'Amolgado' },
        { code: 'G3', des: 'Arestas vivas' },
        { code: 'H', des: 'Fissurado / descascado / corroído / derretido' },
        { code: 'H1', des: 'Fissurado / descascado' },
        { code: 'H2', des: 'Corroído' },
        { code: 'H4', des: 'Divergência de tinta / cor' },
        { code: 'I', des: 'Solto / desprendido / espanado' },
        { code: 'I1', des: 'Não soldado ou colado / rutura de soldadura' },
        { code: 'J', des: 'Abanar / instável' },
        { code: 'J1', des: 'Equipamento mal nivelado' },
        { code: 'J2', des: 'A vibrar' },
        { code: 'J3', des: 'Ruidoso' },
        { code: 'K', des: 'Fuga (mecânica)' },
        { code: 'K1', des: 'Fuga acessível' },
        { code: 'K2', des: 'Fuga inacessível' },
        { code: 'K3', des: 'Fuga externa por oxidação no tubo de condensação' },
        { code: 'L', des: 'Seco (sem lubrificação)' },
        { code: 'L1', des: 'Refrigerante insuficiente / em excesso' },
        { code: 'L2', des: 'Refrigerante incorreto' },
        { code: 'M', des: 'Corpo estranho' },
        { code: 'M1', des: 'Bloqueado / entupido' },
        { code: 'N', des: 'Componente elétrico / módulo com defeito' },
        { code: 'P', des: 'Desalinhamento elétrico / configuração errada' },
        { code: 'P1', des: 'Demasiado quente / temperatura alta' },
        { code: 'P2', des: 'Demasiado frio / temperatura baixa' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'Q', des: 'Curto-circuito' },
        { code: 'R', des: 'Circuito aberto' },
        { code: 'S', des: 'Fuga (elétrica) / passagem' },
        { code: 'T', des: 'Mau contacto / ligação deficiente' },
        { code: 'T1', des: 'Ligação de terra deficiente' },
        { code: 'Y', des: 'Componente / módulo errado' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Z', des: 'Componente / módulo em falta' },
    ],
    KA1: [
        { code: 'A001', des: 'Cabo de alimentação com ficha' },
        { code: 'A002', des: 'Resistência de aquecimento' },
        { code: 'A003', des: 'Luz piloto / indicador' },
        { code: 'A004', des: 'Lâmpada / lâmpada incandescente' },
        { code: 'A005', des: 'Cablagem / chicote de cabos' },
        { code: 'A006', des: 'Bloco de terminais / régua de bornes' },
        { code: 'A007', des: 'Sensor de temperatura / NTC / PTC' },
        { code: 'A008', des: 'Termóstato / Termorregulador' },
        { code: 'A009', des: 'Condensador' },
        { code: 'A011', des: 'Filtro RFI / EMC' },
        { code: 'A013', des: 'Eletroválvula' },
        { code: 'A014', des: 'Fecho da porta' },
        { code: 'A016', des: 'Sensor de turbidez' },
        { code: 'A017', des: 'Sensor de nível de água' },
        { code: 'A019', des: 'Sonda do termóstato' },
        { code: 'A022', des: 'Ventoinha / ventilador' },
        { code: 'A029', des: 'Fusível térmico' },
        { code: 'A032', des: 'Resistência de aquecimento inferior' },
        { code: 'A033', des: 'Resistência de aquecimento traseira / ar quente' },
        { code: 'A034', des: 'Resistência de aquecimento superior' },
        { code: 'A035', des: 'Indicador de calor residual' },
        { code: 'A036', des: 'Pino de conector / tomada' },
        { code: 'A038', des: 'Fusível' },
        { code: 'A039', des: 'Sonda térmica para carne / sensor' },
        { code: 'A041', des: 'Interruptor bipolar' },
        { code: 'A042', des: 'Comutador de 7 posições / energia – simples' },
        { code: 'A043', des: 'Comutador de energia triplo' },
        { code: 'A044', des: 'Comutador de energia para dupla resistência' },
        { code: 'A047', des: 'Lâmpada de iluminação do manípulo' },
        { code: 'A051', des: 'Transformador' },
        { code: 'A052', des: 'Cabo LIN' },
        { code: 'A053', des: 'Faixa de luz do painel de controlo' },
        { code: 'A060', des: 'Elemento de aquecimento cerâmico' },
        { code: 'A061', des: 'Placa de cozedura em ferro fundido' },
        { code: 'A072', des: 'Fluxómetro / medidor de volume de água' },
        { code: 'A073', des: 'Microinterruptor' },
        { code: 'A074', des: 'Contacto magnético / sensor reed' },
        { code: 'A076', des: 'Termóstato de segurança / TCO' },
        { code: 'A081', des: 'Suporte do interruptor da porta (completo)' },
        { code: 'A084', des: 'Díodo de alta tensão' },
        { code: 'A100', des: 'Tubo de micro-ondas' },
        { code: 'A101', des: 'Interruptor de energia' },
        { code: 'A103', des: 'Magnetrão' },
        { code: 'A108', des: 'Atuador' },
        { code: 'A125', des: 'Potenciómetro' },
        { code: 'A143', des: 'Sensor de sal' },
        { code: 'A149', des: 'Sensor de abrilhantador' },
        { code: 'A151', des: 'Conjunto hidráulico do motor' },
        { code: 'A158', des: 'Gerador de vapor' },
        { code: 'A183', des: 'Interruptor de atraso' },
        { code: 'A187', des: 'Válvula de comutação / Distribuidor' },
        { code: 'A199', des: 'Gerador de indução' },
        { code: 'A202', des: 'Motor do prato rotativo' },
        { code: 'A203', des: 'Fusível de alta tensão (HV)' },
        { code: 'A204', des: 'Inverter' },
        { code: 'A208', des: 'Módulo Wi-Fi' },
        { code: 'A209', des: 'Aplicação móvel (App)' },
        { code: 'B003', des: 'Mangueira de ligação interna' },
        { code: 'C001', des: 'Unidade de controlo (placa lógica, potência)' },
        { code: 'C002', des: 'Ecrã / teclado / tátil' },
        { code: 'C003', des: 'Painel de controlo' },
        { code: 'C004', des: 'Manípulo seletor (temperatura, centrifugação)' },
        { code: 'C006', des: 'Interruptor (chave)' },
        { code: 'C010', des: 'Manípulo retrátil (Push-Pull)' },
        { code: 'C011', des: 'Junta do manípulo' },
        { code: 'C012', des: 'Regulação do motor / inverter' },
        { code: 'C015', des: 'Temporizador / conta-minutos' },
        { code: 'D001', des: 'Parte interna da porta' },
        { code: 'D002', des: 'Parte externa da porta' },
        { code: 'D003', des: 'Dobradiça da porta' },
        { code: 'D012', des: 'Junta magnética - vedante da porta' },
        { code: 'D020', des: 'Tranque da porta / bloqueio infantil' },
        { code: 'D023', des: 'Mecanismo de abertura da porta' },
        { code: 'D025', des: 'Porta completa' },
        { code: 'D027', des: 'Vidro intermédio' },
        { code: 'D029', des: 'Conduta de ar da porta' },
        { code: 'D032', des: 'Película protetora / vidro protetor' },
        { code: 'G001', des: 'Parafuso de ajuste do mínimo (gás)' },
        { code: 'G002', des: 'Grelha de suporte / cruzeta do queimador' },
        { code: 'G003', des: 'Tampa do queimador' },
        { code: 'G004', des: 'Espalhador do queimador' },
        { code: 'G005', des: 'Queimador do forno' },
        { code: 'G006', des: 'Queimador do forno – infravermelhos' },
        { code: 'G007', des: 'Tubo do queimador de cozedura' },
        { code: 'G008', des: 'Tubo do queimador do forno / infravermelhos' },
        { code: 'G009', des: 'Suporte do injetor – forno / infravermelhos' },
        { code: 'G010', des: 'Injetor / bico' },
        { code: 'G011', des: 'Torneira de gás – queimador de cozedura' },
        { code: 'G012', des: 'Torneira de gás – controlada por termóstato' },
        { code: 'G013', des: 'Vedante do eixo da torneira de gás' },
        { code: 'G014', des: 'Inserção eletromagnética' },
        { code: 'G015', des: 'Ligação de gás' },
        { code: 'G016', des: 'Vela de ignição / cabo – queimador de cozedura' },
        { code: 'G017', des: 'Vela de ignição – queimador infravermelhos' },
        { code: 'G018', des: 'Termopar – queimador de cozedura' },
        { code: 'G019', des: 'Termopar – queimador do forno' },
        { code: 'G020', des: 'Termopar – queimador infravermelhos' },
        { code: 'G021', des: 'Interruptor do dispositivo de ignição' },
        { code: 'G022', des: 'Dispositivo de ignição' },
        { code: 'G023', des: 'Junta do queimador' },
        { code: 'G024', des: 'Mola do queimador' },
        { code: 'G025', des: 'Pé de suporte da grelha' },
        { code: 'G026', des: 'Freio/freio ómega do veio da torneira de gás' },
        { code: 'G027', des: 'Kit de injetores' },
        { code: 'G028', des: 'Tubo de gás' },
        { code: 'G029', des: 'Joelheiro de ligação / peça angular' },
        { code: 'G030', des: 'Tubagem' },
        { code: 'G031', des: 'Corpo do queimador / suporte do injetor da placa' },
        { code: 'G032', des: 'Queimador' },
        { code: 'G034', des: 'Sonda de ionização' },
        { code: 'G038', des: 'ESPAÇADOR DE SUPORTE DE GRELHA' },
        { code: 'H001', des: 'Corpo do chassis / carcaça' },
        { code: 'H002', des: 'Bancada de trabalho / tampo' },
        { code: 'H004', des: 'Mola' },
        { code: 'H005', des: 'Pés ajustáveis / rodas / perna de nivelamento' },
        { code: 'H008', des: 'Rodapé / plinto / grelha de ventilação' },
        { code: 'H016', des: 'Guia de calha' },
        { code: 'H017', des: 'Chassis diverso' },
        { code: 'H019', des: 'Placa de cozinha' },
        { code: 'H020', des: 'Gaveta, base' },
        { code: 'H022', des: 'Parede protetora, parede traseira' },
        { code: 'H023', des: 'Corpo da dobradiça da porta' },
        { code: 'H024', des: 'Acoplamento cardan' },
        { code: 'H025', des: 'Anel de cobertura / disco' },
        { code: 'H026', des: 'Fixações / elements de aperto' },
        { code: 'H027', des: 'Componentes de iluminação' },
        { code: 'H028', des: 'Moldura / aro' },
        { code: 'H029', des: 'Fundo / base inferior' },
        { code: 'H034', des: 'Serigrafia' },
        { code: 'H038', des: 'Puxador' },
        { code: 'H045', des: 'Grelha de ventilação (chaminé)' },
        { code: 'H046', des: 'Suporte de encastrar' },
        { code: 'H047', des: 'Friso decorativo' },
        { code: 'H048', des: 'Borracha da placa inferior' },
        { code: 'H050', des: 'Filtro de gordura sintético / metálico' },
        { code: 'H054', des: 'Chassis do motor do ventilador' },
        { code: 'H055', des: 'Pá do ventilador' },
        { code: 'H067', des: 'Mangueira' },
        { code: 'H077', des: 'CONSOLA' },
        { code: 'H086', des: 'Puxador do cesto da fritadeira' },
        { code: 'H106', des: 'Isolamento acústico' },
        { code: 'H108', des: 'Isolamento térmico' },
        { code: 'H120', des: 'Alavanca' },
        { code: 'H123', des: 'Direcionador de micro-ondas' },
        { code: 'H126', des: 'Drenagem de vapor/condensação no teto' },
        { code: 'H127', des: 'Drenagem de vapor/condensação na porta' },
        { code: 'H128', des: 'Placa de mica' },
        { code: 'H139', des: 'Hidrociclone' },
        { code: 'H141', des: 'Kit de instalação' },
        { code: 'H142', des: 'Suporte do ventilador' },
        { code: 'L001', des: 'Correia de transmissão' },
        { code: 'L003', des: 'Prato rotativo' },
        { code: 'L004', des: 'Prato de vidro' },
        { code: 'L005', des: 'Aro de suporte do prato rotativo' },
        { code: 'L006', des: 'Eixo/cruzeta de arrastamento do prato' },
        { code: 'M001', des: 'Bomba de entrada / enchimento' },
        { code: 'M002', des: 'Bomba de escoamento / drenagem' },
        { code: 'M003', des: 'Motor elétrico' },
        { code: 'M008', des: 'Motor do espeto rotativo' },
        { code: 'M009', des: 'Motor do ventilador de ar quente / convecção' },
        { code: 'M010', des: 'Motor do ventilador de arrefecimento' },
        { code: 'M013', des: 'Bomba de lavagem / circulação' },
        { code: 'N001', des: 'Cesto inferior' },
        { code: 'N002', des: 'Cesto superior' },
        { code: 'N004', des: 'Roda do cesto' },
        { code: 'N006', des: 'Injetor do chuveiro / aspersor' },
        { code: 'N007', des: 'Braço aspersor inferior' },
        { code: 'N008', des: 'Braço aspersor superior' },
        { code: 'P002', des: 'Suporte do cesto' },
        { code: 'P006', des: 'Filtro de carvão' },
        { code: 'R003', des: 'Filtro' },
        { code: 'R005', des: 'Tampa do depósito de água' },
        { code: 'R008', des: 'Depósito de água' },
        { code: 'T003', des: 'Rolamento de esferas' },
        { code: 'T011', des: 'Contrapeso frontal' },
        { code: 'T024', des: 'Cuba em aço inoxidável' },
        { code: 'V001', des: 'Cavidade do forno / interior do forno' },
        { code: 'V002', des: 'Parede frontal' },
        { code: 'V003', des: 'Junta do forno / vedante' },
        { code: 'V005', des: 'Resguardo / cobertura do motor de convecção' },
        { code: 'V006', des: 'Filtro de gordura' },
        { code: 'V007', des: 'Guia do tabuleiro de cozedura' },
        { code: 'V008', des: 'Tabuleiro de cozedura' },
        { code: 'V009', des: 'Chaminé, tubo de ventilação' },
        { code: 'V010', des: 'Grelha de suporte / grelha auxiliar' },
        { code: 'V011', des: 'Fecho das guias' },
        { code: 'V012', des: 'Grelha' },
        { code: 'V014', des: 'Prato de vidro / prato de cozedura a vapor' },
        { code: 'W001', des: 'Mangueira de entrada de água' },
        { code: 'W002', des: 'Mangueira de escoamento / esgoto' },
        { code: 'W005', des: 'Tubo do pressóstato' },
        { code: 'W011', des: 'Anel de vedação / junta da bomba' },
        { code: 'W012', des: 'Filtro' },
        { code: 'W015', des: 'Distribuidor de detergente / gaveta' },
        { code: 'W018', des: 'Abraçadeira de arame' },
        { code: 'W025', des: 'Interruptor Aquastop / flutuador' },
        { code: 'W038', des: 'Junta da válvula de retenção' },
        { code: 'W040', des: 'Mangueira do sistema "Aqua Stop"' },
        { code: 'W047', des: 'Salt container' },
        { code: 'W049', des: 'Air-break' },
        { code: 'W051', des: 'Water tank' },
        { code: 'W054', des: 'Sifão' },
        { code: 'W055', des: 'Watertapplug / valve' },
        { code: 'W061', des: 'Gasket' },
        { code: 'W077', des: 'Tube upper spray arm' },
        { code: 'W078', des: 'Tube lower spray arm' },
        { code: 'W086', des: 'Anti slurp cap' },
        { code: 'W087', des: 'Drain tub / plastic tub' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Z001', des: 'Manual de instalação / manual do utilizador' },
        { code: 'Z002', des: 'Oscilações na tensão de rede elétrica' },
        { code: 'Z003', des: 'Espaço/instalação/temperatura ambiente inadequada' },
        { code: 'Z004', des: 'Pressão de água inadequada' },
        { code: 'Z005', des: 'Sifão entupido' },
        { code: 'Z007', des: 'Pressão de gás inadequada' },
        { code: 'Z012', des: 'Relatório após aprovação' },
    ],
    LS1: [
        { code: '1', des: 'Problema de software' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '6', des: 'Incapaz de diagnosticar a avaria' },
        { code: '7', des: 'Incorretamente cablado / montado' },
        { code: '9', des: 'Desalinhamento elétrico / configuração errada' },
        { code: 'B2', des: 'Problema de embalagem' },
        { code: 'B3', des: 'Problema de acessórios' },
        { code: 'D3', des: 'Problema na placa Inverter' },
        { code: 'E', des: 'Problema na bateria' },
        { code: 'F', des: 'Problema nos óculos 3D' },
        { code: 'G', des: 'Problema de Software' },
        { code: 'H', des: 'Problema de embalagem' },
        { code: 'I', des: 'Problema na base' },
        { code: 'J', des: 'Problema na placa de alimentação (Power Board)' },
        { code: 'NDMP', des: 'Problema no chip DMD' },
        { code: 'X', des: 'Problemas de configuração' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'ZA', des: 'Defeito mecânico' },
        { code: 'ZD', des: 'Dano físico' },
        { code: 'ZM', des: 'Corpo estranho' },
        { code: 'ZU', des: 'Utilização incorreta pelo cliente' },
        { code: 'ZX', des: 'Outro defeito' },
    ],
    MP1: [
        { code: '1', des: 'Problema de software' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '6', des: 'Incapaz de diagnosticar a avaria' },
        { code: '9', des: 'Desalinhamento elétrico / configuração errada' },
        { code: 'N', des: 'Componente elétrico / módulo com defeito' },
        { code: 'O', des: 'Problema no painel' },
        { code: 'ZA', des: 'Defeito mecânico' },
        { code: 'ZD', des: 'Dano físico' },
        { code: 'ZU', des: 'Utilização incorreta pelo cliente' },
        { code: 'ZX', des: 'Outro defeito' },
    ],
    PAD: [
        { code: '1', des: 'Painel tátil (Touch screen) com defeito' },
        { code: '2', des: 'Painel LCD/LED com defeito' },
        { code: '3', des: 'Placa principal (Main board) com defeito' },
        { code: '4', des: 'Botão de energia com defeito' },
        { code: '5', des: 'Câmara frontal com defeito' },
        { code: '6', des: 'Câmara traseira com defeito' },
        { code: '7', des: 'Bateria com defeito' },
        { code: '8', des: 'Microfone com defeito' },
        { code: '9', des: 'Altifalante com defeito' },
        { code: 'A', des: 'Lanterna / Flash com defeito' },
        { code: 'B', des: 'Motor com defeito' },
        { code: 'C', des: 'Antena NFC com defeito' },
        { code: 'D', des: 'Antena GPS com defeito' },
        { code: 'E', des: 'Antena Wi-Fi com defeito' },
        { code: 'F', des: 'Nenhum problema encontrado (NPF)' },
        { code: 'G', des: 'Problema de software' },
        { code: 'H', des: 'Entrada USB partida' },
        { code: 'I', des: 'Entrada HDMI partida' },
        { code: 'J', des: 'Transformador de corrente com defeito' },
        { code: 'K', des: 'Cabo USB com defeito' },
        { code: 'L', des: 'Ligação solta' },
        { code: 'M', des: 'Incapaz de diagnosticar a avaria' },
        { code: 'N', des: 'Componente elétrico / módulo com defeito' },
        { code: 'O', des: 'Botão de volume partido' },
        { code: 'P', des: 'Acessório errado ou em falta' },
        { code: 'Q', des: 'Defeito na superfície' },
        { code: 'R', des: 'Problema na aplicação (App)' },
        { code: 'S', des: 'Configuração errada do sistema' },
        { code: 'T', des: 'Cabo LVDS com defeito' },
        { code: 'W', des: 'Danos por água / líquidos' },
        { code: 'ZA', des: 'Defeito mecânico' },
        { code: 'ZD', des: 'Dano físico' },
        { code: 'ZU', des: 'Utilização incorreta pelo cliente' },
        { code: 'ZX', des: 'Outro defeito' },
    ],
    POS: [
        { code: '2DBF', des: 'Falha na placa do segundo ecrã' },
        { code: '2DPF', des: 'Falha no segundo ecrã' },
        { code: 'CABF', des: 'Falha no cabo' },
        { code: 'HDDF', des: 'Falha no disco rígido (HDD)' },
        { code: 'IVFL', des: 'Falha no Inverter' },
        { code: 'LCDF', des: 'Falha no painel LCD' },
        { code: 'MBFL', des: 'Falha na placa principal (Mainboard)' },
        { code: 'OTHR', des: 'Outros' },
        { code: 'RAMF', des: 'Falha na memória RAM' },
        { code: 'TCBF', des: 'Falha na placa de controlo tátil' },
        { code: 'TPFL', des: 'Falha no painel tátil' },
    ],
    RF1: [
        { code: '1', des: 'Problema de software (NÃO causado pelo utilizador)' },
        { code: '12', des: 'Configuração ou instalação incorreta do programa' },
        { code: '14', des: 'Problema de configuração do software' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '4', des: 'Nenhum problema encontrado - mal-entendido do cliente' },
        { code: '5', des: 'Nenhum problema encontrado - condições locais' },
        { code: '51', des: 'Tensão de rede elétrica com falha' },
        { code: '6', des: 'Incapaz de diagnosticar a avaria' },
        { code: '7', des: 'Incorretamente cablado / montado' },
        { code: '72', des: 'Tentativa de reparação anterior incorreta' },
        { code: '73', des: 'Dano / defeito causado durante o processo de reparação' },
        { code: '8', des: 'Falha de instalação' },
        { code: '81', des: 'Ligação incorreta do equipamento' },
        { code: '9', des: 'Utilização incorreta pelo cliente' },
        { code: '91', des: 'Sobrecarregado / carregamento incorreto' },
        { code: '92', des: 'Manutenção deficiente' },
        { code: 'B', des: 'Sujo / obstruído' },
        { code: 'D', des: 'Cortado / partido' },
        { code: 'E', des: 'Deformado' },
        { code: 'F', des: 'Partido / quebrado' },
        { code: 'F1', des: 'Encravado / preso' },
        { code: 'F3', des: 'Congelado / com gelo' },
        { code: 'F4', des: 'Dobrado / vincado / esmagado' },
        { code: 'G', des: 'Riscado / amolgado / arestas vivas' },
        { code: 'G2', des: 'Amolgado' },
        { code: 'G3', des: 'Arestas vivas' },
        { code: 'H', des: 'Fissurado / descascado / corroído / derretido' },
        { code: 'H1', des: 'Fissurado / descascado' },
        { code: 'H2', des: 'Corroído' },
        { code: 'H4', des: 'Divergência de tinta / cor' },
        { code: 'I', des: 'Solto / desprendido / espanado' },
        { code: 'I1', des: 'Não soldado ou colado / rutura de soldadura' },
        { code: 'J', des: 'Abanar / instável' },
        { code: 'J1', des: 'Equipamento mal nivelado' },
        { code: 'J2', des: 'A vibrar' },
        { code: 'J3', des: 'Ruidoso' },
        { code: 'K', des: 'Fuga (mecânica)' },
        { code: 'K1', des: 'Fuga acessível' },
        { code: 'K2', des: 'Fuga inacessível' },
        { code: 'K3', des: 'Fuga externa por oxidação no tubo de condensação' },
        { code: 'L', des: 'Seco (sem lubrificação)' },
        { code: 'L1', des: 'Refrigerante insuficiente / em excesso' },
        { code: 'L2', des: 'Refrigerante incorreto' },
        { code: 'M', des: 'Corpo estranho' },
        { code: 'M1', des: 'Bloqueado / entupido' },
        { code: 'N', des: 'Componente elétrico / módulo com defeito' },
        { code: 'P', des: 'Desalinhamento elétrico / configuração errada' },
        { code: 'P1', des: 'Demasiado quente / temperatura alta' },
        { code: 'P2', des: 'Demasiado frio / temperatura baixa' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'Q', des: 'Curto-circuito' },
        { code: 'R', des: 'Circuito aberto' },
        { code: 'S', des: 'Fuga (elétrica) / passagem' },
        { code: 'T', des: 'Mau contacto / ligação deficiente' },
        { code: 'T1', des: 'Ligação de terra deficiente' },
        { code: 'Y', des: 'Wrong component / module' },
        { code: 'Y4', des: 'Product installation' },
        { code: 'Z', des: 'Missing component / module' },
    ],
    SH1: [
        { code: 'A1', des: 'Falha no interruptor geral' },
        { code: 'A2', des: 'A tecla/botão soltou-se' },
        { code: 'A3', des: 'Tecla/botão sem resposta' },
        { code: 'A4', des: 'O fusível fundiu' },
        { code: 'A5', des: 'Fuga elétrica no transformador' },
        { code: 'A6', des: 'Transformador com ruído elétrico anómalo' },
        { code: 'A7', des: 'Bolhas na superfície / contração' },
        { code: 'A8', des: 'Oxidação / ferrugem na superfície' },
        { code: 'A9', des: 'Falha no magnetrão' },
        { code: 'B1', des: 'Fuga elétrica no magnetrão' },
        { code: 'B2', des: 'Falha na lâmpada' },
        { code: 'B3', des: 'Linha/cabo da lâmpada solto' },
        { code: 'B4', des: 'Falha na placa da fonte de alimentação' },
        { code: 'B5', des: 'Falha na ligação do cabo de alimentação' },
        { code: 'B6', des: 'Falha no temporizador' },
        { code: 'B7', des: 'Falha no motor do ventilador ou ventilador solto' },
        { code: 'B8', des: 'Fuga elétrica no motor do ventilador' },
        { code: 'B9', des: 'Motor do ventilador muito ruidoso' },
        { code: 'C1', des: 'Díodo de alta tensão anómalo' },
        { code: 'C2', des: 'Fissura, deformação, distorção' },
        { code: 'C3', des: 'Falha no painel de controlo' },
        { code: 'C4', des: 'Tranque de segurança da porta não fecha' },
        { code: 'C5', des: 'Falha no trinco de segurança da porta' },
        { code: 'C6', des: 'Falha no interruptor geral' },
        { code: 'C7', des: 'Falta de ligação à terra na instalação' },
        { code: 'C8', des: 'Porta mal vedada com fuga' },
        { code: 'C9', des: 'Ruído anómalo na dobradiça da porta' },
        { code: 'D1', des: 'Problema na estrutura da porta' },
        { code: 'D2', des: 'Cablagem interna danificada' },
        { code: 'D3', des: 'Dissipação de calor deficiente' },
        { code: 'D4', des: 'Falha no regulador' },
        { code: 'D5', des: 'Regulador não comuta' },
        { code: 'D6', des: 'Danos externos (Amolgadelas, riscos, quebras)' },
        { code: 'D7', des: 'Ecrã / visualização anómala' },
        { code: 'D8', des: 'Falha no motor do prato rotativo' },
        { code: 'D9', des: 'Fuga elétrica no motor do prato rotativo' },
        { code: 'E1', des: 'Ruído anómalo no motor do prato rotativo' },
        { code: 'E2', des: 'Problema no eixo do prato rotativo' },
        { code: 'Y4', des: 'Instalação do produto' },
    ],
    TV1: [
        { code: '2', des: 'Problema no módulo Wi-Fi' },
        { code: '4', des: 'Problema na placa T-CON' },
        { code: '5', des: 'Problema na placa do controlo remoto' },
        { code: '8', des: 'Problema na placa de botões (Keypad)' },
        { code: 'A', des: 'Problema nos altifalantes' },
        { code: 'B', des: 'Problema nos botões' },
        { code: 'D', des: 'Problema na tampa frontal/traseira' },
        { code: 'D1', des: 'Problema na placa principal e placa de potência' },
        { code: 'D2', des: 'Problema na placa principal (Main Board)' },
        { code: 'D3', des: 'Problema na placa Inverter' },
        { code: 'D5', des: 'Problema no controlo remoto' },
        { code: 'D6', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: 'D7', des: 'Problema na placa de retroiluminação (Backlight)' },
        { code: 'D8', des: 'Problema nas réguas de LEDs' },
        { code: 'G', des: 'Problema de Software' },
        { code: 'H', des: 'Problema de embalagem' },
        { code: 'I', des: 'Problema na base' },
        { code: 'J', des: 'Problema na placa de alimentação (Power Board)' },
        { code: 'J1', des: 'Problema no transformador AC' },
        { code: 'J2', des: 'Problema no cabo de alimentação' },
        { code: 'K', des: 'DOA (Defeituoso de fábrica / Fora da caixa)' },
        { code: 'M', des: 'Problema no cabo de ligação' },
        { code: 'O', des: 'Problema no painel' },
        { code: 'P', des: 'Problema por danos físicos' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'Q', des: 'Problema no cabo LVDS' },
        { code: 'S', des: 'Problema de configuração do utilizador' },
        { code: 'T', des: 'Problema de transporte / logística' },
        { code: 'T1', des: 'Ligação de terra deficiente' },
        { code: 'T2', des: 'Suporte difusor' },
        { code: 'T3', des: 'Problema na barra de som' },
        { code: 'T4', des: 'Cabo [Rc:Mn-Key/Em/Rc]' },
        { code: 'T5', des: 'Compatibilidade do dispositivo' },
        { code: 'T6', des: 'Cabo [Ub:Main-Wifi]' },
        { code: 'T7', des: 'Problema no sinal de entrada' },
        { code: 'T8', des: 'Problema na ventoinha' },
        { code: 'T9', des: 'Problema no circuito de comando da ventoinha' },
        { code: 'TA', des: 'Problema em dispositivo externo' },
        { code: 'TB', des: 'Compatibilidade com dispositivo externo' },
        { code: 'TC', des: 'Problema de Internet' },
        { code: 'TD', des: 'Falha na atualização OTA' },
        { code: 'TE', des: 'Problema no disco rígido (HDD)' },
        { code: 'TF', des: 'Problema no botão interruptor' },
        { code: 'TG', des: 'Problema no módulo de voz' },
        { code: 'W', des: 'Problema por utilização incorreta do cliente' },
        { code: 'Y4', des: 'Instalação do produto' },
    ],
    WC1: [
        { code: '111', des: 'FUGA INTERIOR' },
        { code: '112', des: 'FUGA EXTERIOR' },
        { code: '131', des: 'COMPRESSOR DEMASIADO RUIDOSO' },
        { code: '132', des: 'FLUXO DE REFRIGERANTE MUITO RUIDOSO' },
        { code: '133', des: 'PÁ DA VENTOINHA RUIDOSA' },
        { code: '141', des: 'TUBAGEM DO CIRCUITO DE REFRIGERANTE OBSTRUÍDA' },
        { code: '142', des: 'TUBO DE ÁGUA ENTUPIDO / OBSTRUÍDO' },
        { code: '151', des: 'EVAPORADOR COM GELO' },
        { code: '152', des: 'ZONA DE ARMAZENAMENTO COM GELO' },
        { code: '161', des: 'FUGA NO TABULEIRO DE DESCARGA' },
        { code: '162', des: 'FUGA DE ÁGUA NO INTERIOR' },
        { code: '211', des: 'FALHA NA PLACA ELETRÓNICA DE CONTROLO (PCB)' },
        { code: '221', des: 'FALHA NA PLACA ELETRÓNICA DO DISPLAY (PCB)' },
        { code: '231', des: 'FALHA NO MOTOR' },
        { code: '232', des: 'MOTOR RUIDOSO' },
        { code: '241', des: 'FALHA NO COMPRESSOR' },
        { code: '242', des: 'FALHA DO CONDENSADOR DO COMPRESSOR' },
        { code: '251', des: 'FALHA NO SENSOR DE DESCONGELAÇÃO' },
        { code: '252', des: 'FALHA NO SENSOR' },
        { code: '261', des: 'MAU FUNCIONAMENTO DA ELETROVÁLVULA' },
        { code: '271', des: 'MAU FUNCIONAMENTO DO FUSÍVEL' },
        { code: '281', des: 'MAU FUNCIONAMENTO DA RESISTÊNCIA' },
        { code: '291', des: 'MAU FUNCIONAMENTO DO TEMPORIZADOR' },
        { code: '2A1', des: 'MAU FUNCIONAMENTO DO TRANSFORMADOR' },
        { code: '2B1', des: 'LÂMPADA FUNDIDA' },
        { code: '311', des: 'CORPO / CHASSIS DANIFICADO' },
        { code: '312', des: 'CORPO / CHASSIS ENFERRUJADO' },
        { code: '321', des: 'FISSURAS NO INTERIOR' },
        { code: '322', des: 'DANOS EM COMPONENTES INTERNOS' },
        { code: '323', des: 'COMPONENTES INTERNOS EM FALTA / SOLTOS' },
        { code: '331', des: 'BORRACHA DA PORTA DEFEITUOSA' },
        { code: '332', des: 'BORRACHA DA PORTA DANIFICADA' },
        { code: '341', des: 'ERRO DE IMPRESSÃO' },
        { code: '342', des: 'GRAFISMO / SERIGRAFIA DESPRENDIDA' },
        { code: '343', des: 'CAIXA DE CARTÃO DANIFICADA' },
        { code: '351', des: 'PORTA SOLTA' },
        { code: '352', des: 'BORRACHA DA PORTA DESPRENDIDA' },
        { code: '353', des: 'PUXADOR SOLTO' },
        { code: 'AUG', des: 'Código de Defeito Genérico para Frigoríficos AU' },
        { code: 'Y4', des: 'Instalação do produto' },
    ],
    WM1: [
        { code: '1', des: 'Problema de software (NÃO causado pelo utilizador)' },
        { code: '12', des: 'Configuração ou instalação incorreta do programa' },
        { code: '13', des: 'Software defeituoso ou incompleto' },
        { code: '3', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: '5', des: 'Nenhum problema encontrado (condições locais)' },
        { code: '51', des: 'Tensão de rede elétrica com falha' },
        { code: '6', des: 'Incapaz de diagnosticar a avaria' },
        { code: '7', des: 'Incorretamente cablado / montado' },
        { code: '9', des: 'Utilização incorreta pelo cliente' },
        { code: '91', des: 'Sobrecarregado / carregamento incorreto' },
        { code: '92', des: 'Manutenção deficiente' },
        { code: 'B', des: 'Sujo / obstruído' },
        { code: 'C', des: 'Desalinhamento mecânico' },
        { code: 'C1', des: 'Demasiado largo' },
        { code: 'D', des: 'Cortado / partido' },
        { code: 'E', des: 'Deformado' },
        { code: 'F1', des: 'Encravado / preso' },
        { code: 'F2', des: 'Ajustado / muito justo' },
        { code: 'F4', des: 'Dobrado / vincado / esmagado' },
        { code: 'G', des: 'Riscado / amolgado / arestas vivas' },
        { code: 'G3', des: 'Arestas vivas' },
        { code: 'H1', des: 'Fissurado / descascado' },
        { code: 'H2', des: 'Corroído' },
        { code: 'H4', des: 'Divergência de tinta / cor' },
        { code: 'I', des: 'Solto / desprendido / espanado' },
        { code: 'I1', des: 'Não soldado ou colado / rutura de soldadura' },
        { code: 'J1', des: 'Equipamento mal nivelado' },
        { code: 'J2', des: 'A vibrar' },
        { code: 'K', des: 'Fuga (mecânica)' },
        { code: 'K1', des: 'Fuga acessível' },
        { code: 'K2', des: 'Fuga inacessível' },
        { code: 'L', des: 'Seco (sem lubrificação)' },
        { code: 'L1', des: 'Refrigerante insuficiente / em excesso' },
        { code: 'M', des: 'Corpo estranho' },
        { code: 'M1', des: 'Bloqueado / entupido' },
        { code: 'N', des: 'Componente elétrico ou módulo com defeito' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'Q', des: 'Curto-circuito' },
        { code: 'R', des: 'Circuito aberto' },
        { code: 'T', des: 'Mau contacto / ligação deficiente' },
        { code: 'T2', des: 'Parafusos / parafusos sextavados soltos' },
        { code: 'T3', des: 'Terminais soltos' },
        { code: 'V404', des: 'Problema de montagem' },
        { code: 'W202', des: 'Falha de componente' },
        { code: 'W506', des: 'Atuador / atuador de travagem não se move' },
        { code: 'W513', des: 'Vara de suspensão sem amortecimento' },
        { code: 'W521', des: 'Entrega de armazém incorreta' },
        { code: 'W540', des: 'Sem motivos aparentes' },
        { code: 'W545', des: 'Correia a patinar / deslizar' },
        { code: 'W565', des: 'Problemas de rede do utilizador' },
        { code: 'W583', des: 'Proteção térmica do motor ativa' },
        { code: 'W585', des: 'Modelos inconsistentes' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Z', des: 'Componente ou módulo em falta' },
    ],
};

export const repairCodes = {
    AC1: [
        { code: 'A1', des: 'Descongelação manual' },
        { code: 'AAC1', des: 'Substituir sensor de temperatura' },
        { code: 'AAC3', des: 'Substituir placa de controlo' },
        { code: 'AAC4', des: 'Substituir compressor' },
        { code: 'AAC5', des: 'Substituir motor do ventilador' },
        { code: 'AAC6', des: 'Substituir resistência de aquecimento' },
        { code: 'AAC7', des: 'Substituir placa de exibição / display' },
        { code: 'AAC8', des: 'Substituir tabuleiro de água' },
        { code: 'AAC9', des: 'Substituir válvula de quatro vias' },
        { code: 'AACA', des: 'Substituir válvula de expansão' },
        { code: 'AF', des: 'Substituição de tampas ou acessórios' },
        { code: 'AR1M', des: 'Reparar placa principal (Main board)' },
        { code: 'ARC1', des: 'Substituir placa do filtro' },
        { code: 'ARC2', des: 'Substituir módulo IPM' },
        { code: 'ARC3', des: 'Substituir fusível' },
        { code: 'ARC5', des: 'Substituir ventilador do motor' },
        { code: 'ARC6', des: 'Substituir condensador' },
        { code: 'ARC7', des: 'Substituir evaporador' },
        { code: 'ARC8', des: 'Substituir válvula de 2/3 vias' },
        { code: 'ARC9', des: 'Substituir componentes' },
        { code: 'ARCG', des: 'Ajustar outros componentes' },
        { code: 'ARCH', des: 'Soldadura e carga de gás' },
        { code: 'ARCJ', des: 'Troca integral do produto' },
        { code: 'ARCK', des: 'Devolução do produto' },
        { code: 'ARCL', des: 'Limpeza e manutenção' },
        { code: 'ARCO', des: 'Resolução de problema de instalação' },
        { code: 'ARCR', des: 'Apenas inspeção / diagnóstico' },
        { code: 'ARCS', des: 'Ajustar cabo de encaixe / fichas' },
        { code: 'ARCT', des: 'Apenas carga de refrigerante' },
        { code: 'ARCU', des: 'Limpar o filtro' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'F', des: 'Lubrificação' },
        { code: 'P', des: 'Nenhuma avaria encontrada' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'RRCI', des: 'Apenas carga de gás' },
        { code: 'U', des: 'Esclarecido presencialmente com o cliente' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Z301', des: 'Substituição do evaporador/condensador' },
    ],
    BAR: [
        { code: '1', des: 'Correção de software / Reinicialização (Reset)' },
        { code: '2', des: 'Atualização de software' },
        { code: 'A', des: 'Substituição de componentes' },
        { code: 'C', des: 'Alinhamento elétrico' },
        { code: 'C5', des: 'Calibração' },
        { code: 'D2', des: 'Soldadura' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'E', des: 'Limpeza' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'V', des: 'Orçamento recusado' },
        { code: 'Y', des: 'Devolução sem reparação' },
        { code: 'Y1', des: 'Abatido para sucata' },
        { code: 'Y2', des: 'Abatido para sucata com reembolso' },
        { code: 'Z', des: 'Troca de equipamento' },
        { code: 'Z1', des: 'Troca de produto (reparação demasiado cara)' },
        { code: 'Z7', des: 'Troca de acessório do produto' },
    ],
    CD1: [
        { code: '1', des: 'Restaurar definições de fábrica (Reset)' },
        { code: '2', des: 'Atualização de software' },
        { code: '3', des: 'Apenas inspeção / diagnóstico' },
        { code: 'A', des: 'Peça de substituição' },
        { code: 'A6', des: 'Substituição da placa Inverter' },
        { code: 'A8', des: 'Configuração de Internet' },
        { code: 'AB', des: 'Substituição do painel' },
        { code: 'AD', des: 'Instalação de produção' },
        { code: 'AE', des: 'Instalação padrão' },
        { code: 'AF', des: 'Substituição de tampas ou acessórios' },
        { code: 'AG', des: 'Configuração inicial' },
        { code: 'AJ', des: 'Substituição das réguas de LEDs' },
        { code: 'AK', des: 'Reparação ao nível dos componentes da placa' },
        { code: 'B9', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: 'C1', des: 'Cobrança por cancelamento de serviço ao cliente' },
        { code: 'C4', des: 'Instalação de software' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'E', des: 'Limpeza' },
        { code: 'E1', des: 'Troca de TV' },
        { code: 'HTR2', des: 'Substituição do dispositivo de projeção sem fios' },
        { code: 'J6', des: 'Troca de módulo LED e envio para reparação ASC' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'LR01', des: 'Restaurar tensão' },
        { code: 'O', des: 'Recondicionamento / renovação' },
        { code: 'OW', des: 'Fora de garantia' },
        { code: 'PR', des: 'Reparação do painel' },
        { code: 'R', des: 'Devolução / Reembolso da TV' },
        { code: 'SXR1', des: 'Reinstalação do cabo FFC' },
        { code: 'SXR2', des: 'Reinstalação da moldura tátil' },
        { code: 'SXR3', des: 'Substituição do OPS' },
        { code: 'SXR4', des: 'Devolução/Reembolso do OPS' },
        { code: 'T1', des: 'Reclamação à Logística' },
        { code: 'TC', des: 'Cobrança pelo serviço prestado' },
        { code: 'TP', des: 'Problema de responsabilidade de terceiros' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'Y4', des: 'Instalação do produto' },
    ],
    DH1: [
        { code: 'AAC1', des: 'Substituir sensor de temperatura' },
        { code: 'AAC2', des: 'Substituir termóstato' },
        { code: 'AAC3', des: 'Substituir placa de controlo' },
        { code: 'AAC4', des: 'Substituir compressor' },
        { code: 'AAC5', des: 'Substituir motor do ventilador' },
        { code: 'AAC6', des: 'Substituir resistência de aquecimento' },
        { code: 'AAC7', des: 'Substituir placa de exibição / display' },
        { code: 'AAC8', des: 'Substituir tabuleiro de água' },
        { code: 'AAC9', des: 'Substituir válvula de quatro vias' },
        { code: 'AACA', des: 'Substituir válvula de expansão' },
        { code: 'ABC1', des: 'Configuração inicial' },
        { code: 'ARC1', des: 'Substituir placa do filtro' },
        { code: 'ARC2', des: 'Substituir módulo IPM' },
        { code: 'ARC3', des: 'Substituir fusível' },
        { code: 'ARC4', des: 'Substituir condensador elétrico' },
        { code: 'ARC5', des: 'Substituir ventilador do motor' },
        { code: 'ARC6', des: 'Substituir condensador' },
        { code: 'ARC7', des: 'Substituir evaporador' },
        { code: 'ARC8', des: 'Substituir válvula de 2/3 vias' },
        { code: 'ARC9', des: 'Substituir outros componentes' },
        { code: 'ARCA', des: 'Ajuste do rolamento do motor do ventilador' },
        { code: 'ARCB', des: 'Ajuste do tubo de água' },
        { code: 'ARCC', des: 'Ajuste do tubo do circuito refrigerante' },
        { code: 'ARCD', des: 'Ajuste do termóstato' },
        { code: 'ARCE', des: 'Ajuste do evaporador' },
        { code: 'ARCF', des: 'Ajuste do sensor' },
        { code: 'ARCG', des: 'Ajuste de outros elementos' },
        { code: 'ARCH', des: 'Soldadura ou carga de gás' },
        { code: 'ARCI', des: 'Apenas carga de gás' },
        { code: 'ARCJ', des: 'Troca direta / Permuta' },
        { code: 'ARCK', des: 'Reembolso do equipamento' },
        { code: 'ARCL', des: 'Limpeza e manutenção' },
        { code: 'ARCM', des: 'Impossível reparar por causa imputável ao cliente' },
        { code: 'ARCN', des: 'Danificado no transporte' },
        { code: 'ARCO', des: 'Resolução de problema de instalação' },
        { code: 'ARCP', des: 'Clientes não estavam em casa' },
        { code: 'ARCQ', des: 'Clientes recusam a reparação' },
        { code: 'ARCR', des: 'Apenas inspeção / diagnóstico' },
        { code: 'ART1', des: 'Reparação economicamente inviável (UER)' },
        { code: 'FD', des: 'Destruição em campo / Abate no local' },
    ],
    DW1: [
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'R001', des: 'Devolução e reembolso' },
        { code: 'R002', des: 'Limpeza e esclarecimento do utilizador' },
        { code: 'R003', des: 'Substituição de componente' },
        { code: 'R004', des: 'Apenas inspeção / diagnóstico' },
        { code: 'R005', des: 'Ajuste mecânico' },
        { code: 'X1', des: 'Configuração de Entrega + Instalação de 2 a 7 Equipamentos' },
        { code: 'X2', des: 'Sem Instalação - Cliente Recusa' },
        { code: 'X3', des: 'Sem Entrega - Apresentada Explicação' },
        { code: 'X4', des: 'Sem Entrega - Instalação - Recolha' },
        { code: 'X5', des: 'Entrega Sem Instalação' },
        { code: 'X6', des: 'Entrega Sem Instalação + Recolha' },
        { code: 'X7', des: 'Configuração de Entrega + Instalação' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Y41', des: 'Configuração de demonstração 4 a 8' },
        { code: 'Y9', des: 'Configuração de demonstração' },
        { code: 'YA', des: 'Configuração de demonstração 2 a 3' },
    ],
    FF1: [
        { code: '1', des: 'Correção de software / Reinicialização (Reset)' },
        { code: '2', des: 'Atualização de software' },
        { code: '5', des: 'Nenhum problema encontrado' },
        { code: 'A', des: 'Substituição de componentes' },
        { code: 'B', des: 'Alinhamento mecânico' },
        { code: 'D', des: 'Ressoldadura' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'I2', des: 'Instalação Premium Side by Side' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'N', des: 'Manutenção' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'R', des: 'Devolução do equipamento / reembolso' },
        { code: 'RG', des: 'Recarga de gás' },
        { code: 'RRCR', des: 'Limpeza do sistema e substituição de componente' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'V', des: 'Orçamento recusado' },
        { code: 'X1', des: 'Configuração de Entrega e Instalação de 2 a 7 Equipamentos' },
        { code: 'X2', des: 'Sem Instalação - Consumidor Recusa' },
        { code: 'X3', des: 'Sem Entrega - Apresentada Explicação' },
        { code: 'X4', des: 'Sem Entrega - Instalação - Recolha OA' },
        { code: 'X5', des: 'Entrega - Sem Instalação' },
        { code: 'X6', des: 'Entrega Sem Instalação - Recolha OA' },
        { code: 'X7', des: 'Configuração de Entrega + Instalação' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Y41', des: 'Configuração de demonstração 4 a 8' },
        { code: 'Y5', des: 'Configuração da porta SR PP' },
        { code: 'Y6', des: 'Inversão do sentido de abertura da porta' },
        { code: 'Y7', des: 'Instalação de Side by Side (SBS)' },
        { code: 'Y8', des: 'Instalação de entrada de água SBS' },
        { code: 'Y9', des: 'Configuração de demonstração' },
        { code: 'YA', des: 'Configuração de demonstração 2 a 3' },
        { code: 'Z', des: 'Troca de equipamento' },
        { code: 'Z101', des: 'Reparação do sistema de gás' },
        { code: 'Z105', des: 'Alinhamento elétrico' },
        { code: 'Z203', des: 'Apenas inspeção / diagnóstico' },
    ],
    KA1: [
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'R001', des: 'Devolução e reembolso' },
        { code: 'R002', des: 'Limpeza e esclarecimento do utilizador' },
        { code: 'R003', des: 'Substituição de componente' },
        { code: 'R004', des: 'Apenas inspeção / diagnóstico' },
        { code: 'R005', des: 'Ajuste mecânico' },
        { code: 'R006', des: 'Conversão / transformação para gás' },
        { code: 'X1', des: 'Configuração de Entrega e Instalação de 2 a 7 Equipamentos' },
        { code: 'X2', des: 'Sem Instalação - Consumidor Recusa' },
        { code: 'X3', des: 'Sem Entrega - Apresentada Explicação' },
        { code: 'X4', des: 'Sem Entrega - Instalação - Recolha OA' },
        { code: 'X5', des: 'Entrega - Sem Instalação' },
        { code: 'X6', des: 'Entrega Sem Instalação - Recolha OA' },
        { code: 'X7', des: 'Configuração de Entrega + Instalação' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Y41', des: 'Configuração de demonstração 4 a 8' },
        { code: 'Y9', des: 'Configuração de demonstração' },
        { code: 'YA', des: 'Configuração de demonstração 2 a 3' },
    ],
    LS1: [
        { code: '2', des: 'Atualização de software' },
        { code: 'A', des: 'Peça de substituição' },
        { code: 'A2', des: 'Substituição de módulo/painel' },
        { code: 'A3', des: 'Substituição da placa principal' },
        { code: 'A4', des: 'Substituição da placa de alimentação' },
        { code: 'A5', des: 'Substituição da placa principal e placa de alimentação' },
        { code: 'A6', des: 'Substituição da placa Inverter' },
        { code: 'A7', des: 'Substituição da bateria' },
        { code: 'A8', des: 'Substituição da placa TCON' },
        { code: 'A9', des: 'Substituição de óculos 3D' },
        { code: 'AA', des: 'Substituição da caixa de cartão / embalagem' },
        { code: 'ADMP', des: 'Substituição do CHIP DMD' },
        { code: 'AE', des: 'Instalação padrão' },
        { code: 'AG', des: 'Configuração inicial' },
        { code: 'AH', des: 'Instalação na parede' },
        { code: 'C', des: 'Alinhamento elétrico' },
        { code: 'C3', des: 'Ajuste' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'DW', des: 'Reparação da roda difusora' },
        { code: 'E', des: 'Limpeza' },
        { code: 'ER', des: 'Reparação do motor / ótica (Engine)' },
        { code: 'FCW', des: 'Reparação da roda de filtros de cor' },
        { code: 'FW', des: 'Reparação da roda fluorescente' },
        { code: 'J', des: 'Desmontagem' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'LS', des: 'Reparação da fonte laser' },
        { code: 'O', des: 'Recondicionamento' },
        { code: 'R1', des: 'Voltar a conectar o equipamento' },
        { code: 'R2', des: 'Inicialização' },
        { code: 'R3', des: 'Alterar configuração' },
        { code: 'R4', des: 'Renovar' },
        { code: 'R5', des: 'Suplementar / Completar' },
        { code: 'SS', des: 'Abate / destruição no local (Scrap on site)' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'V', des: 'Orçamento recusado' },
        { code: 'X1', des: 'Cobrança por cancelamento de serviço ao cliente' },
        { code: 'Y', des: 'Devolução / Retorno' },
        { code: 'Y1', des: 'Reembolso' },
        { code: 'Y4', des: 'Instalação de produção' },
        { code: 'Z', des: 'Troca / Permuta' },
        { code: 'ZX', des: 'Outros métodos' },
    ],
    MP1: [
        { code: '2', des: 'Atualização de software' },
        { code: 'A2', des: 'Substituição de módulo/painel' },
        { code: 'A3', des: 'Substituição da placa principal' },
        { code: 'A6', des: 'Substituição de tampa ou acessório' },
        { code: 'C', des: 'Alinhamento elétrico' },
        { code: 'O', des: 'Recondicionamento' },
        { code: 'Y', des: 'Devolução sem reparação' },
        { code: 'Y1', des: 'Reembolso' },
        { code: 'Z', des: 'Troca de equipamento' },
        { code: 'ZX', des: 'Outros métodos' },
    ],
    PAD: [
        { code: '1', des: 'Reiniciar o sistema (Reset)' },
        { code: '2', des: 'Atualização de software' },
        { code: '3', des: 'Reparar placa principal (Main board)' },
        { code: '4', des: 'Substituir entrada USB' },
        { code: 'A1', des: 'Substituir painel tátil (Touch screen)' },
        { code: 'A2', des: 'Substituir painel LCD/LED' },
        { code: 'A3', des: 'Substituição da placa principal' },
        { code: 'A4', des: 'Substituir botão / tecla' },
        { code: 'A5', des: 'Substituir câmara frontal' },
        { code: 'A6', des: 'Substituir câmara traseira' },
        { code: 'A7', des: 'Substituir bateria' },
        { code: 'A8', des: 'Substituir microfone' },
        { code: 'A9', des: 'Substituir altifalante' },
        { code: 'AA', des: 'Substituir lanterna / flash' },
        { code: 'AB', des: 'Substituir motor' },
        { code: 'AC', des: 'Substituir antena NFC' },
        { code: 'AD', des: 'Substituir antena GPS' },
        { code: 'AE', des: 'Substituir antena Wi-Fi' },
        { code: 'AF', des: 'Substituição de tampa ou acessório' },
        { code: 'AJ', des: 'Substituir/reparar transformador de corrente' },
        { code: 'AK', des: 'Substituir cabo USB' },
        { code: 'AL', des: 'Substituir cabo LVDS' },
        { code: 'AM', des: 'Substituir botão de energia' },
        { code: 'B', des: 'Voltar a conectar fios ou efetuar alinhamento mecânico' },
        { code: 'C', des: 'Alinhamento elétrico' },
        { code: 'Y', des: 'Devolução / Retorno' },
        { code: 'Y1', des: 'Reembolso' },
        { code: 'Z', des: 'Troca / Permuta' },
        { code: 'Z1', des: 'Troca de Tablet e cabo USB' },
        { code: 'Z2', des: 'Fora de garantia e sem reparação' },
        { code: 'ZX', des: 'Outros métodos' },
    ],
    POS: [
        { code: '2DBR', des: 'Substituir placa de sinal do segundo ecrã' },
        { code: '2DRP', des: 'Substituir segundo ecrã' },
        { code: 'CABR', des: 'Substituir cabo' },
        { code: 'HDDR', des: 'Substituir disco rígido (HDD)' },
        { code: 'IVRP', des: 'Substituir Inverter' },
        { code: 'LCDR', des: 'Substituir painel LCD' },
        { code: 'MBRP', des: 'Substituir placa principal (Mainboard)' },
        { code: 'OTHR', des: 'Outros' },
        { code: 'RAMR', des: 'Substituir memória RAM' },
        { code: 'TCBR', des: 'Substituir placa de controlo tátil' },
        { code: 'TPRP', des: 'Substituir painel tátil' },
    ],
    RF1: [
        { code: '1', des: 'Correção de software / Reinicialização (Reset)' },
        { code: '2', des: 'Atualização de software' },
        { code: '5', des: 'Nenhum problema encontrado' },
        { code: 'A', des: 'Substituição de componentes' },
        { code: 'B', des: 'Alinhamento mecânico' },
        { code: 'D', des: 'Ressoldadura' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'I2', des: 'Instalação Premium Side by Side' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'N', des: 'Manutenção' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'R', des: 'Devolução do equipamento / reembolso' },
        { code: 'RG', des: 'Recarga de gás' },
        { code: 'RRCR', des: 'Limpeza do sistema e substituição de componente' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'V', des: 'Orçamento recusado' },
        { code: 'X1', des: 'Configuração de Entrega e Instalação de 2 a 7 Equipamentos' },
        { code: 'X2', des: 'Sem Instalação - Consumidor Recusa' },
        { code: 'X3', des: 'Sem Entrega - Apresentada Explicação' },
        { code: 'X4', des: 'Sem Entrega - Instalação - Recolha OA' },
        { code: 'X5', des: 'Entrega - Sem Instalação' },
        { code: 'X6', des: 'Entrega Sem Instalação - Recolha OA' },
        { code: 'X7', des: 'Configuração de Entrega + Instalação' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Y41', des: 'Configuração de demonstração 4 a 8' },
        { code: 'Y5', des: 'Configuração da porta SR PP' },
        { code: 'Y6', des: 'Inversão do sentido de abertura da porta' },
        { code: 'Y7', des: 'Instalação de Side by Side (SBS)' },
        { code: 'Y8', des: 'Instalação de entrada de água SBS' },
        { code: 'Y9', des: 'Configuração de demonstração' },
        { code: 'YA', des: 'Configuração de demonstração 2 a 3' },
        { code: 'Z', des: 'Troca de equipamento' },
        { code: 'Z101', des: 'Reparação do sistema de gás' },
        { code: 'Z105', des: 'Alinhamento elétrico' },
        { code: 'Z203', des: 'Apenas inspeção / diagnóstico' },
    ],
    SH1: [
        { code: 'A1', des: 'Substituir o interruptor geral' },
        { code: 'A2', des: 'Substituir o magnetrão' },
        { code: 'A3', des: 'Substituir o painel de controlo' },
        { code: 'A4', des: 'Substituir a placa de exibição / display' },
        { code: 'A5', des: 'Substituir o regulador' },
        { code: 'A6', des: 'Substituir o temporizador' },
        { code: 'A7', des: 'Substituir o fusível' },
        { code: 'A8', des: 'Substituir a placa da fonte de alimentação' },
        { code: 'A9', des: 'Substituir o motor do ventilador' },
        { code: 'B1', des: 'Substituir o motor do prato rotativo' },
        { code: 'B2', des: 'Substituir a porta' },
        { code: 'B3', des: 'Substituir a lâmpada' },
        { code: 'B4', des: 'Substituir o díodo de alta tensão' },
        { code: 'B5', des: 'Substituir o transformador' },
        { code: 'B6', des: 'Ajustar o interruptor' },
        { code: 'B7', des: 'Ajustar a linha / cablagem' },
        { code: 'B8', des: 'Ajustar o pé de nivelamento' },
        { code: 'B9', des: 'Ajustar a borracha/vedante da porta' },
        { code: 'C1', des: 'Ajustar a dobradiça da porta' },
        { code: 'C2', des: 'Ajustar o veio do prato rotativo' },
        { code: 'C3', des: 'Ajustar o ventilador' },
        { code: 'C4', des: 'Troca de máquina' },
        { code: 'C5', des: 'Devolução de máquina' },
        { code: 'C6', des: 'Danos provocados no transporte' },
        { code: 'C7', des: 'Análise laboratorial / testes' },
        { code: 'C8', des: 'Recusa de reparação' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'Y4', des: 'Instalação de produção' },
    ],
    TV1: [
        { code: '1', des: 'Restaurar definições de fábrica (Reset)' },
        { code: '2', des: 'Atualização de software' },
        { code: '3', des: 'Apenas inspeção / diagnóstico' },
        { code: 'A', des: 'Peça de substituição' },
        { code: 'A6', des: 'Substituição da placa Inverter' },
        { code: 'A8', des: 'Substituição da placa TCON' },
        { code: 'AB', des: 'Substituição do painel' },
        { code: 'AD', des: 'Instalação de produção' },
        { code: 'AE', des: 'Instalação padrão' },
        { code: 'AF', des: 'Substituição de tampas ou acessórios' },
        { code: 'AG', des: 'Configuração inicial' },
        { code: 'AJ', des: 'Substituição das réguas de LEDs' },
        { code: 'AK', des: 'Reparação ao nível dos componentes da placa' },
        { code: 'B9', des: 'Nenhum problema encontrado (equipamento dentro das especificações)' },
        { code: 'C1', des: 'Cobrança por cancelamento de serviço ao cliente' },
        { code: 'C4', des: 'Instalação de software' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'E', des: 'Limpeza' },
        { code: 'E1', des: 'Troca de TV' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'O', des: 'Recondicionamento / renovação' },
        { code: 'OC1', des: 'Substituição de Open Cell' },
        { code: 'OC2', des: 'Reparação de Open Cell' },
        { code: 'OW', des: 'Fora de garantia' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'PR', des: 'Reparação do painel' },
        { code: 'R', des: 'Devolução / Reembolso da TV' },
        { code: 'T1', des: 'Reclamação à Logística' },
        { code: 'TC', des: 'Cobrança pelo serviço prestado' },
        { code: 'TP', des: 'Problema de responsabilidade de terceiros' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'Y4', des: 'Instalação de produção' },
    ],
    WC1: [
        { code: '2', des: 'Atualização de software' },
        { code: '3', des: 'Apenas inspeção / diagnóstico' },
        { code: 'A', des: 'Substituição de componentes' },
        { code: 'C', des: 'Carga de refrigerante' },
        { code: 'E', des: 'Limpo / efetuada limpeza' },
        { code: 'F', des: 'Lubrificado' },
        { code: 'G', des: 'Reparação elétrica efetuada' },
        { code: 'H', des: 'Reparação mecânica efetuada' },
        { code: 'I', des: 'Modificado' },
        { code: 'J', des: 'Componente removido' },
        { code: 'K', des: 'Componente adicionado' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'M', des: 'Especificação técnica / Cliente aconselhado' },
        { code: 'P', des: 'Nenhuma avaria encontrada' },
        { code: 'R', des: 'Devolução do equipamento / reembolso' },
        { code: 'S', des: 'Soldadura' },
        { code: 'W', des: 'Trabalho de pré-codificação' },
        { code: 'X', des: 'Cancelado' },
        { code: 'X1', des: 'Configuração de Entrega e Instalação de 2 a 7 Equipamentos' },
        { code: 'X2', des: 'Sem Instalação - Consumidor Recusa' },
        { code: 'X3', des: 'Sem Entrega - Apresentada Explicação' },
        { code: 'X4', des: 'Sem Entrega - Instalação - Recolha OA' },
        { code: 'X5', des: 'Entrega - Sem Instalação' },
        { code: 'X6', des: 'Entrega Sem Instalação - Recolha OA' },
        { code: 'X7', des: 'Configuração de Entrega + Instalação' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Y41', des: 'Configuração de demonstração 4 a 8' },
        { code: 'Y9', des: 'Configuração de demonstração' },
        { code: 'YA', des: 'Configuração de demonstração 2 a 3' },
        { code: 'Z', des: 'Troca de equipamento' },
    ],
    WM1: [
        { code: '5', des: 'Nenhum problema encontrado' },
        { code: 'A', des: 'Substituição de componentes' },
        { code: 'B', des: 'Alinhamento mecânico' },
        { code: 'DOAR', des: 'Processo DOA rejeitado' },
        { code: 'E', des: 'Limpeza' },
        { code: 'F', des: 'Lubrificação' },
        { code: 'L', des: 'Verificação funcional' },
        { code: 'PC', des: 'Recolha de Produto Defeituoso' },
        { code: 'R', des: 'Devolução do equipamento / reembolso' },
        { code: 'RC3', des: 'Substituir motor de lavagem' },
        { code: 'U', des: 'Esclarecimento ao cliente' },
        { code: 'W103', des: 'Substituição do tambor / cuba traseira / rolamentos' },
        { code: 'W205', des: 'Apenas inspeção / diagnóstico' },
        { code: 'X1', des: 'Configuração de Entrega e Instalação de 2 a 7 Equipamentos' },
        { code: 'X2', des: 'Sem Instalação - Consumidor Recusa' },
        { code: 'X3', des: 'Sem Entrega - Apresentada Explicação' },
        { code: 'X4', des: 'Sem Entrega - Instalação - Recolha OA' },
        { code: 'X5', des: 'Entrega - Sem Instalação' },
        { code: 'X6', des: 'Entrega Sem Instalação - Recolha OA' },
        { code: 'X7', des: 'Configuração de Entrega + Instalação' },
        { code: 'Y4', des: 'Instalação do produto' },
        { code: 'Y41', des: 'Configuração de demonstração 4 a 8' },
        { code: 'Y9', des: 'Configuração de demonstração' },
        { code: 'YA', des: 'Configuração de demonstração 2 a 3' },
        { code: 'Z', des: 'Troca de equipamento' },
        { code: 'Z101', des: 'Reparação do sistema de gás' },
    ],
};

export default {
    warrantyTypes,
    serviceTypes,
    delayReasons,
    unsolvedReasons,
    inProgressStatuses,
    partsOrderTypes,
    partsItemStatuses,
    codeGroups,
    symptomCodes,
    defectCodes,
    repairCodes,
};